import "@heytradeapps/ds-lit/components/Text/text.js";
import "@heytradeapps/ds-lit/components/TextField/textField.js";
import "@heytradeapps/ds-lit/components/Icons/chevronLeftIcon.js";
import "@heytradeapps/ds-lit/components/Icons/legalIcon.js";
import "@heytradeapps/ds-lit/components/Icons/shareIcon.js";
import "@heytradeapps/ds-lit/components/Button/button.js";
import "@heytradeapps/ds-lit/components/Icons/faqIcon.js";
import { css as d, unsafeCSS as p, LitElement as m, html as c, nothing as h } from "lit";
import { property as o, state as _, customElement as u, eventOptions as U } from "lit/decorators.js";
import "@heytradeapps/ds-lit/components/Icons/longArrowUpIcon.js";
import "@heytradeapps/ds-lit/components/Icons/squareIcon.js";
import { createRef as C, ref as w } from "lit/directives/ref.js";
import "@heytradeapps/ds-lit/components/Modal/modal.js";
import "@heytradeapps/ds-lit/components/Icons/facebookIcon.js";
import "@heytradeapps/ds-lit/components/Icons/xIcon.js";
import "@heytradeapps/ds-lit/components/Icons/whatsappIcon.js";
import "@heytradeapps/ds-lit/components/Icons/emailIcon.js";
import { I18n as ce } from "i18n-js";
import { css as ie, LitElement as J, html as S } from "lit-element";
import "@heytradeapps/ds-lit/components/Icons/reloadIcon.js";
import "@heytradeapps/ds-lit/components/Icons/thumbUpFilledIcon.js";
import "@heytradeapps/ds-lit/components/Icons/thumbDownFilledIcon.js";
import "@heytradeapps/ds-lit/components/Icons/thumbUpIcon.js";
import "@heytradeapps/ds-lit/components/Icons/thumbDownIcon.js";
import "@heytradeapps/ds-lit/components/HeatMapChart/heatMapChart.js";
import "@heytradeapps/ds-lit/components/Icons/chatbotIcon.js";
import "@heytradeapps/ds-lit/components/TabBar/tabBar.js";
import "@heytradeapps/ds-lit/components/TradingViewSimpleChart/tradingViewSimpleChart.js";
import "@heytradeapps/ds-lit/components/Markdown/markdown.js";
import "@heytradeapps/ds-lit/components/ScatterPlotChart/scatterPlotChart.js";
import "@heytradeapps/ds-lit/components/BarChart/barChart.js";
import "@heytradeapps/ds-lit/components/Avatar/avatar.js";
import "@heytradeapps/ds-lit/components/StockPerformance/stockPerformance.js";
import "@heytradeapps/ds-lit/components/Icons/assetIcon.js";
import { formatMoney as de } from "@heytradeapps/ds-lit/utils/formatMoney.utils.js";
import "@heytradeapps/ds-lit/components/Icons/plusIcon.js";
import { PeriodEnum as ue, UltraiService as pe } from "@heytradeapps/api-sdk";
import "@heytradeapps/ds-lit/components/Icons/spinnerIcon.js";
const me = d`.chatbot-input__btn{--btn-size: 28px;border:none;background:none;cursor:pointer;background-color:var(--labelPrimarySubtleInitial);padding:.390625rem;border-radius:calc(var(--btn-size) / 2);display:inline-flex;align-items:center;justify-content:center;height:var(--btn-size);width:var(--btn-size)}.chatbot-input__btn:disabled{background-color:var(--iconNeutralSoft);cursor:not-allowed}.chatbot-input__btn:not(:disabled):focus,.chatbot-input__btn:not(:disabled):hover{background:var(--actionPrimaryHover)}`;
var he = Object.defineProperty, ve = Object.getOwnPropertyDescriptor, D = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? ve(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && he(e, a, i), i;
};
let x = class extends m {
  constructor() {
    super(...arguments), this.placeholder = "Ask something to Finny AI", this.value = "", this.isLoading = !1, this.inputValue = "", this.inputRef = C();
  }
  resetInput() {
    this.inputRef.value && (this.inputValue = "", this.inputRef.value.value = "");
  }
  handleSend() {
    this.inputValue.trim() && this.dispatchEvent(
      new CustomEvent("send", {
        detail: {
          value: this.inputValue
        }
      })
    ), this.resetInput();
  }
  handleCancel() {
    this.dispatchEvent(new CustomEvent("cancel"));
  }
  handleKeyDown(t) {
    t.key === "Enter" && this.handleSend();
  }
  renderIconRight() {
    const t = this.inputValue, e = {
      onClick: () => this.isLoading ? this.handleCancel() : this.handleSend(),
      disabled: !t.length,
      "aria-label": this.isLoading ? "cancel prompt" : "send prompt"
    }, a = this.isLoading ? c`<square-icon
          size="12"
          color="iconNeutralStrongInverted"
        ></square-icon>` : c`<long-arrow-up-icon
          size="20"
          color="iconNeutralStrongInverted"
        ></long-arrow-up-icon>`;
    return c`
      <button
        @click=${e.onClick}
        slot="right"
        type="submit"
        .disabled=${e.disabled}
        aria-label=${e["aria-label"]}
        class="chatbot-input__btn"
      >
        ${a}
      </button>
    `;
  }
  handleChange(t) {
    this.inputValue = t.target.value;
  }
  render() {
    return c`
      <div class="input-container d-flex d-flex-col">
        <ht-text-field
          type="text"
          ${w(this.inputRef)}
          @change=${this.handleChange}
          @keydown=${this.handleKeyDown}
          placeholder=${this.placeholder}
        >
          ${this.renderIconRight()}
        </ht-text-field>
      </div>
    `;
  }
};
x.styles = d`
    ${p(me)}
  `;
D([
  o({ type: String })
], x.prototype, "placeholder", 2);
D([
  o({ type: String })
], x.prototype, "value", 2);
D([
  o({ type: Boolean })
], x.prototype, "isLoading", 2);
D([
  _()
], x.prototype, "inputValue", 2);
D([
  _()
], x.prototype, "inputRef", 2);
x = D([
  u("chatbot-input")
], x);
const ge = d`.modal-share__header{display:flex;justify-content:space-between;align-items:center;width:100%;height:72px;border-bottom:1px solid var(--strokeNeutralSoftInitial)}.modal-share__header-title{flex:1 0 60%;display:flex;text-align:center;justify-content:center}.modal-share__header-side{flex:0 0 20%}.modal-share__content{display:flex;align-items:center;justify-content:center}.social-links{display:flex;flex-direction:column;gap:var(--spacingSmaller)}.social-link{display:flex;align-items:center;gap:var(--spacingTinyPlus);color:var(--textNeutralStrong);text-decoration:none}.social-link:hover{color:var(--labelPrimarySubtleInitial)}`;
var ye = Object.defineProperty, fe = Object.getOwnPropertyDescriptor, X = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? fe(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && ye(e, a, i), i;
};
let O = class extends m {
  constructor() {
    super(...arguments), this.modalRef = C(), this.title = "Share this content", this.closeLabel = "Close";
  }
  showModal() {
    const t = this.modalRef.value;
    t && t.show();
  }
  closeModal() {
    const t = this.modalRef.value;
    t && t.hide();
  }
  render() {
    return c`
      <ht-modal
        title=${this.title}
        .open=${!1}
        .backdropClose=${!0}
        .showBackdrop=${!0}
        class="modal-share"
        size="small"
        ${w(this.modalRef)}
      >
        <div slot="header" class="modal-share__header">
          <div class="modal-share__header-side"></div>
          <ht-text
            preset="headline3"
            class="modal-share__header-title"
            align="center"
            text-wrap="pretty"
          >
            ${this.title}
          </ht-text>
          <div class="modal-share__header-side">
            <ht-button
              button-type="link"
              auto-width
              class="modal-share__header-close"
              @click=${this.closeModal}
            >
              ${this.closeLabel}
            </ht-button>
          </div>
        </div>
        <div class="modal-share__content">
          <div class="social-links">
            <a class="social-link" href="https://facebook.com" target="_blank">
              <facebook-icon size="24" color="currentColor"></facebook-icon>
              <ht-text preset="smallText" color="inherit">Facebook</ht-text>
            </a>
            <a class="social-link" href="https://twitter.com" target="_blank">
              <x-icon size="24" color="currentColor"></x-icon>
              <ht-text preset="smallText" color="inherit">Twitter</ht-text>
            </a>
            <a class="social-link" href="https://whatsapp.com" target="_blank">
              <whatsapp-icon size="24" color="currentColor"></whatsapp-icon>
              <ht-text preset="smallText" color="inherit">Whatsapp</ht-text>
            </a>
            <a class="social-link" href="https://whatsapp.com" target="_blank">
              <email-icon size="24" color="currentColor"></email-icon>
              <ht-text preset="smallText" color="inherit">Email</ht-text>
            </a>
          </div>
        </div>
      </ht-modal>
    `;
  }
};
O.styles = d`
    ${p(ge)}
  `;
X([
  o({ type: String })
], O.prototype, "title", 2);
X([
  o({ type: String, attribute: "close-label" })
], O.prototype, "closeLabel", 2);
O = X([
  u("modal-share")
], O);
const be = d`.modal-legal__header{display:flex;justify-content:space-between;align-items:center;width:100%;height:72px;border-bottom:1px solid var(--strokeNeutralSoftInitial)}.modal-legal__header-title{flex:1 0 100%;display:flex;text-align:center;justify-content:center}.modal-legal__content{display:flex;flex-direction:column;padding:0 var(--spacingSmaller)}.modal-legal__content-text{display:inline;margin-top:var(--spacingTiny)}.modal-legal__content-text p{display:inline}.modal-legal__content-text a{text-align:left;text-decoration:underline;display:inline-block;font-family:var(--ff400);font-size:var(--fontSizeExtraBase);line-height:var(--lineHeightBase);color:var(--textNeutralStrongInitial)}.modal-legal__footer{display:flex;justify-content:center;align-items:center;width:100%;border-top:1px solid var(--strokeNeutralSoftInitial);padding-top:var(--spacingSmaller);margin-top:var(--spacingSmaller)}.modal-legal__footer-button{width:100%}`, Se = {
  title: "Finny AI",
  conversation: {
    initialMessage: "Hey there! It’s Finny, here are some helpful questions you can ask me about any stock. Select the option and type in the sotck",
    initialQuestions: {
      question1: "Compare an asset with the main financial ratios within it’s sector",
      question2: "How is an asset positioned to perform during the current phase of the economic cycle?",
      question3: "How is an asset exposed to different investment styles?",
      question4: "Key company summary of an asset"
    }
  },
  error: {
    title: "Oops! Something went wrong",
    description: "Please check the status of your network connection and try again."
  },
  prompts: {
    more: "View more prompts",
    hide: "Hide prompts",
    title: "All queries",
    question1: "What is the Value factor of a company?",
    question2: "What is Apple's P/E?",
    question3: "Nike's ROE vs competitors",
    question4: "What company's high Growth means?"
  },
  input: {
    placeholder: "Ask me anything to Finny AI"
  },
  share: {
    title: "Share full conversation",
    close: "Close"
  },
  legalDisclaimer: {
    body: "You are interacting with an artificial intelligence system. The predictions and data analysis provided by Finny AI are derived from internal source of information controlled by us. These predictions are only for reference, they are not investment advice. Investing entails risks; make decisions with caution. For any consult about HeyTrade's products and services, or to obtain detailed information or exercise your data protection rights please contact our",
    button: "Understood",
    bodyConnector: "or the",
    customerSupport: "customer success team",
    faq: "FAQs.",
    header: "Please read carefully",
    title: "Legal note",
    close: "Close",
    legalHref: "https://www.google.com",
    customerSupportHref: "https://www.google.com"
  },
  asset: {
    button: "View details"
  },
  loading: "Analysing your query",
  scatterPlot: {
    axis1: "Defensive-Grow",
    axis2: "Cyclical-Defensive",
    axis3: "Value-Defensive",
    axis4: "Cyclical-Value"
  }
}, xe = {
  title: "Ask Finny about",
  newChat: "New chat",
  prompts: {
    question1: "Compare %{company} with the main financial ratios within it’s sector",
    question2: "How is %{company} positioned to perform during the current phase of the economic cycle?",
    question3: "How is %{company} exposed to different investment styles?",
    question4: "Key company summary of %{company}"
  }
}, Pe = {
  chat: Se,
  askFinnyAbout: xe
}, _e = {
  title: "Finny AI",
  conversation: {
    initialMessage: "¡Hola!. Soy Finny, aquí tienes algunas preguntas útiles que puedes hacerme sobre cualquier acción. Selecciona la opción y escribe el sotck",
    initialQuestions: {
      question1: "Comparar un activo con los principales ratios financieros de su sector",
      question2: "¿Cómo está posicionado un activo para desempeñarse durante la fase actual del ciclo económico?",
      question3: "¿Cómo está un activo expuesto a diferentes estilos de inversión?",
      question4: "Resumen empresarial de un activo"
    }
  },
  error: {
    title: "¡Ups! Algo salió mal",
    description: "Por favor, verifica el estado de tu conexión de red y vuelve a intentarlo."
  },
  prompts: {
    more: "Ver más prompts",
    hide: "Ocultar prompts",
    title: "Todas las consultas",
    question1: "¿Qué es el factor de valor de una empresa?",
    question2: "¿Cuál es el P/E de Apple?",
    question3: "¿Cuál es el ROE de Nike en comparación con sus competidores?",
    question4: "¿Qué significa un alto crecimiento para una empresa?"
  },
  input: {
    placeholder: "Pregúntame lo que sea a Finny AI"
  },
  share: {
    title: "Compartir conversación completa",
    close: "Cerrar"
  },
  legalDisclaimer: {
    body: "Usted está interactuando con un sistema de inteligencia artificial. Las predicciones y los análisis de datos proporcionados por Finny AI son obtenidas de información interna controlada por nosotros. Son predicciones sólo a modo de referencia, no son consejos recomendaciones de inversión. Invertir conlleva riesgos; tome decisiones con precaución. Para cualquier consulta sobre los productos y servicios de HeyTrade, o para obtener información detallada o ejercitar sus derechos de protección de datos póngase en contacto con nuestro",
    button: "Entendido",
    bodyConnector: "o con el",
    customerSupport: "equipo de atención al cliente",
    faq: "apartado de preguntas frecuentes.",
    header: "Por favor, leer con cuidado",
    title: "Nota legal",
    close: "Cerrar",
    legalHref: "https://www.google.com",
    customerSupportHref: "https://www.google.com"
  },
  asset: {
    button: "Ver detalles"
  },
  loading: "Analizando tu pregunta",
  scatterPlot: {
    axis1: "Crecimiento Defensivo",
    axis2: "Defensivo Cíclico",
    axis3: "Valor Defensivo",
    axis4: "Valor Cíclico"
  }
}, Ce = {
  title: "Preguntar a Finny sobre",
  newChat: "Nuevo chat",
  prompts: {
    question1: "Compara %{company} con los principales ratios financieros dentro de su sector",
    question2: "¿Cómo está posicionada %{company} para desempeñarse durante la fase actual del ciclo económico?",
    question3: "¿Cómo está %{company} expuesta a diferentes estilos de inversión?",
    question4: "Resumen de la empresa %{company}"
  }
}, we = {
  chat: _e,
  askFinnyAbout: Ce
};
class ke {
  constructor() {
    this.i18n = new ce({
      en: Pe,
      es: we
    }), this.i18n.defaultLocale = "en", this.i18n.locale = this.i18n.defaultLocale;
  }
  translate(e, a) {
    return this.i18n.t(e, a);
  }
  updateLocale(e) {
    this.i18n.locale = e;
  }
  updateTranslations(e) {
    this.i18n.store(e);
  }
}
const l = new ke();
var Ie = Object.defineProperty, $e = Object.getOwnPropertyDescriptor, z = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? $e(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && Ie(e, a, i), i;
};
let k = class extends m {
  constructor() {
    super(...arguments), this.modalRef = C(), this.title = "Legal disclaimer", this.closeLabel = "Close", this.faqHref = "", this.customerSupportHref = "";
  }
  showModal() {
    const t = this.modalRef.value;
    t && t.show();
  }
  closeModal() {
    const t = this.modalRef.value;
    t && t.hide();
  }
  handleButtonClick() {
    this.dispatchEvent(new CustomEvent("accept"));
  }
  render() {
    return c`
      <ht-modal
        title=${this.title}
        .open=${!1}
        .backdropClose=${!1}
        .showBackdrop=${!0}
        class="modal-legal"
        size="big"
        ${w(this.modalRef)}
      >
        <div slot="header" class="modal-legal__header">
          <div class="modal-legal__header-side"></div>
          <ht-text
            preset="headline3"
            class="modal-legal__header-title"
            align="center"
            text-wrap="pretty"
          >
            ${this.title}
          </ht-text>
        </div>
        <div class="modal-legal__content">
          <ht-text
            preset="subtitle2"
            text=${l.translate("chat.legalDisclaimer.header")}
          ></ht-text>
          <div class="modal-legal__content-text">
            <ht-text preset="paragraph2">
              <p>${l.translate("chat.legalDisclaimer.body")}</p>
              <a href=${this.customerSupportHref} target="_blank">
                ${l.translate("chat.legalDisclaimer.customerSupport")}
              </a>
              <p>${l.translate("chat.legalDisclaimer.bodyConnector")}</p>
              <a href=${this.faqHref} target="_blank">
                ${l.translate("chat.legalDisclaimer.faq")}
              </a>
            </ht-text>
          </div>
          <div class="modal-legal__footer">
            <ht-button
              button-type="primary"
              class="modal-legal__footer-button"
              @click=${this.handleButtonClick}
              size="medium"
              text-preset="bigText"
              text=${l.translate("chat.legalDisclaimer.button")}
            >
            </ht-button>
          </div>
        </div>
      </ht-modal>
    `;
  }
};
k.styles = d`
    ${p(be)}
  `;
z([
  o({ type: String })
], k.prototype, "title", 2);
z([
  o({ type: String, attribute: "close-label" })
], k.prototype, "closeLabel", 2);
z([
  o({ type: String, attribute: "faq-href" })
], k.prototype, "faqHref", 2);
z([
  o({ type: String, attribute: "customer-support-href" })
], k.prototype, "customerSupportHref", 2);
k = z([
  u("modal-legal")
], k);
const Ne = d`.msg-from-user{display:flex;justify-content:flex-end}.msg-from-user__text{background-color:var(--surfaceCanvasSecondaryInitial);border-radius:var(--borderRadiusSmall);padding:var(--spacingSmaller);width:-moz-fit-content;width:fit-content;max-width:60%;margin-left:auto}.msg-from-user__reload{cursor:pointer;display:flex;align-items:center;justify-content:center;margin-left:var(--spacingTiny)}`;
var Me = Object.defineProperty, Te = Object.getOwnPropertyDescriptor, Z = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? Te(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && Me(e, a, i), i;
};
let A = class extends J {
  constructor() {
    super(...arguments), this.sentence = {
      id: "",
      msg: "",
      error: !1,
      isFromUser: !0,
      date: 0,
      feedback: null
    }, this.isLastMessage = !1;
  }
  handleReload(t, e) {
    this.dispatchEvent(new CustomEvent("reload", { detail: { msg: t, error: e } }));
  }
  render() {
    var t;
    return S`
      <div class="msg-from-user">
        <div class="msg-from-user__text">
          <ht-text preset="paragraph2">${this.sentence.msg}</ht-text>
        </div>
        ${(t = this.sentence) != null && t.error && this.isLastMessage ? S`
              <div
                @click=${() => this.handleReload(this.sentence.msg, !1)}
                class="msg-from-user__reload"
                data-testid="reload-btn"
                role="button"
                aria-hidden="true"
              >
                <reload-icon
                  data-testid="reload-icon"
                  size="24"
                  color="iconNeutralMedium"
                ></reload-icon>
              </div>
            ` : h}
      </div>
    `;
  }
};
A.styles = ie`
    ${p(Ne)}
  `;
Z([
  o({ type: Object })
], A.prototype, "sentence", 2);
Z([
  o({ type: Boolean })
], A.prototype, "isLastMessage", 2);
A = Z([
  u("msg-from-user")
], A);
const He = d`.chatbot-msg-wrapper{display:flex;align-items:flex-start;gap:var(--spacingSmaller)}.chatbot-msg-wrapper__icon{width:var(--spacingMediumPlus);height:var(--spacingMediumPlus);max-width:var(--spacingMediumPlus);max-height:var(--spacingMediumPlus);min-width:var(--spacingMediumPlus);min-height:var(--spacingMediumPlus);border-radius:100%;background-color:var(--surfaceCanvasSecondaryInitial);display:flex;align-items:center;justify-content:center}.chatbot-msg-wrapper__text{margin-top:var(--spacingTiny);width:100%}`;
var Le = Object.defineProperty, Ee = Object.getOwnPropertyDescriptor, ee = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? Ee(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && Le(e, a, i), i;
};
let F = class extends m {
  constructor() {
    super(...arguments), this.iconColor = "iconPrimaryInitial", this.iconSize = 24;
  }
  render() {
    return c`
      <div class="chatbot-msg-wrapper">
        <div class="chatbot-msg-wrapper__icon">
          <chatbot-icon
            .size=${this.iconSize}
            .color=${this.iconColor}
          ></chatbot-icon>
        </div>
        <div class="chatbot-msg-wrapper__text">
          <slot></slot>
        </div>
      </div>
    `;
  }
};
F.styles = d`
    ${p(He)}
  `;
ee([
  o({ type: String })
], F.prototype, "iconColor", 2);
ee([
  o({ type: Number })
], F.prototype, "iconSize", 2);
F = ee([
  u("msg-wrapper")
], F);
const De = d`:host{flex:1 1 45%}.chatbot-asset{display:flex;flex-direction:column;flex:1 1 45%;background-color:var(--surfaceCanvasSecondaryInitial);border-radius:var(--spacingTiny);margin-block:var(--spacingSmallerMinus);padding-inline:var(--spacingSmaller);padding-block:var(--spacingSmaller)}.chatbot-asset__content{display:flex;align-items:center}.chatbot-asset__info{display:flex;flex:1;margin-left:var(--spacingSmaller);align-items:center;justify-content:space-between}.chatbot-asset__info>div:first-child{display:flex;flex-direction:column;gap:var(--spacingTiny)}.chatbot-asset__info>div:last-child{display:flex;flex-direction:column;align-items:end;gap:var(--spacingTiny)}.chatbot-asset__small{align-items:center;flex-direction:row;justify-content:space-between;gap:var(--spacingTiny);cursor:pointer}.chatbot-asset ht-button{margin-top:var(--spacingSmaller)}`;
var qe = Object.defineProperty, Oe = Object.getOwnPropertyDescriptor, Q = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? Oe(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && qe(e, a, i), i;
};
let T = class extends m {
  constructor() {
    super(...arguments), this.asset = {}, this.small = !1;
  }
  get assetPrice() {
    return de(this.asset.price.amount, this.asset.price.currency);
  }
  onClickAsset() {
    this.dispatchEvent(
      new CustomEvent("ClickAsset", {
        detail: this.asset.id,
        composed: !0,
        bubbles: !0
      })
    );
  }
  onClickSmall() {
    this.dispatchEvent(
      new CustomEvent("askFinnyCardClicked", {
        detail: { description: this.asset.prompt },
        bubbles: !0,
        composed: !0
      })
    );
  }
  renderSmall() {
    return c`
      <div
        class="chatbot-asset chatbot-asset__small"
        @click=${this.onClickSmall}
      >
        <ht-avatar
          roundness="full"
          .image="${this.asset.logoUrl}"
          .fallback="${c`<asset-icon size="22"></asset-icon>`}"
          size="mediumPlus"
        >
        </ht-avatar>
        <div class="d-flex d-flex-col">
          <div class="d-flex align-center justify-space-between">
            <ht-text
              preset="caption"
              color="secondary"
              text="${this.asset.ticker}"
            ></ht-text>
            <stock-performance
              .performanceAmount="${this.asset.increaseMoney}"
              .performancePercentage="${this.asset.increasePercentage}"
              type="summary"
              preset="paragraph3"
            ></stock-performance>
          </div>
        </div>
      </div>
    `;
  }
  renderLarge() {
    return c`
      <div class="chatbot-asset">
        <div class="chatbot-asset__content">
          <ht-avatar
            roundness="full"
            .image="${this.asset.logoUrl}"
            .fallback="${c`<asset-icon size="22"></asset-icon>`}"
            size="mediumPlus"
          >
          </ht-avatar>
          <div class="chatbot-asset__info d-flex d-flex-col">
            <div class="d-flex align-center justify-space-between">
              <ht-text
                preset="paragraph2"
                text="${this.asset.companyName}"
              ></ht-text>
              <ht-text
                preset="caption"
                color="secondary"
                text="${this.asset.ticker}"
              ></ht-text>
            </div>
            <div class="d-flex align-center justify-space-between">
              <ht-text preset="subtitle2" text="${this.assetPrice}"></ht-text>
              <stock-performance
                .performanceAmount="${this.asset.increaseMoney}"
                .performancePercentage="${this.asset.increasePercentage}"
                .type="${this.asset.type}"
                noWrap
                plusSymbol
                preset="paragraph3"
              ></stock-performance>
            </div>
          </div>
        </div>
        <ht-button
          buttonType="secondary"
          textPreset="paragraph4"
          @click=${this.onClickAsset}
          >${l.translate("chat.asset.button")}</ht-button
        >
      </div>
    `;
  }
  render() {
    return this.small ? this.renderSmall() : this.renderLarge();
  }
};
T.styles = d`
    ${p(De)}
  `;
Q([
  o({ type: Object })
], T.prototype, "asset", 2);
Q([
  o({ type: Boolean })
], T.prototype, "small", 2);
Q([
  U({ capture: !0 })
], T.prototype, "onClickSmall", 1);
T = Q([
  u("chatbot-asset")
], T);
const Ae = d`.ask-finny-card{display:flex;flex-direction:column;cursor:pointer;padding:0 var(--spacingSmallMinus);background-color:var(--surfaceCanvasSecondaryInitial);border-radius:var(--borderRadiusSmall)}.ask-finny-card:hover{background-color:var(--surfaceCanvasTertiaryInitial);transition:all var(--transitionNormal)}.ask-finny-card div{display:flex;padding:var(--spacingSmallMinus) 0}.ask-finny-card div chevron-left-icon,.ask-finny-card div plus-icon{margin-left:auto;transform:rotate(180deg);align-items:center}`;
var Fe = Object.defineProperty, Re = Object.getOwnPropertyDescriptor, G = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? Re(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && Fe(e, a, i), i;
};
let H = class extends m {
  constructor() {
    super(...arguments), this.description = "", this.icon = "";
  }
  onClickCard(e) {
    this.dispatchEvent(
      new CustomEvent("askFinnyCardClicked", {
        detail: { description: e },
        bubbles: !0,
        composed: !0
      })
    );
  }
  getIcon() {
    return this.icon === "plus" ? c`<plus-icon size="24" color="iconNeutralStrong"></plus-icon>` : this.icon === "chevron" ? c`<chevron-left-icon
        size="24"
        color="iconNeutralStrong"
      ></chevron-left-icon>` : h;
  }
  render() {
    return c`
      <div class="ask-finny-card">
        <div
          role="button"
          tabindex="0"
          aria-hidden="false"
          data-testid="prompt-${this.description}"
          @click=${() => this.onClickCard(this.description)}
        >
          <ht-text
            .text="${this.description}"
            preset="paragraph2"
            class="prompt-card__text"
            color="primary"
          ></ht-text>
          ${this.getIcon()}
        </div>
      </div>
    `;
  }
};
H.styles = d`
    ${p(Ae)}
  `;
G([
  o({ type: String })
], H.prototype, "description", 2);
G([
  o({ type: String })
], H.prototype, "icon", 2);
G([
  U({ capture: !0 })
], H.prototype, "onClickCard", 1);
H = G([
  u("ask-finny-card")
], H);
const ze = d`.chatbot-engine__assets{display:flex;flex-wrap:wrap;width:100%;margin-top:var(--spacingSmaller);gap:var(--spacingSmaller)}.chatbot-engine__assets-small{display:grid;grid-template-columns:repeat(auto-fit,minmax(155px,1fr));gap:var(--spacingSmaller)}.chatbot-engine .other-questions{display:flex;flex-direction:column;flex-wrap:wrap;gap:var(--spacingSmaller);margin-bottom:var(--spacingSmaller)}.chatbot-engine .other-questions .other-questions-title{display:flex;gap:var(--spacingSmaller)}.chatbot-engine .other-questions .other-cards{display:flex;flex-direction:column;flex-wrap:wrap;gap:var(--spacingSmaller)}.chatbot-engine .other-questions chevron-left-icon{transition:all .25s ease-out}.chatbot-engine .other-questions chevron-left-icon.open{transform:rotate(90deg)}.chatbot-engine .other-questions chevron-left-icon.closed{transform:rotate(-90deg)}`;
var We = Object.defineProperty, Be = Object.getOwnPropertyDescriptor, f = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? Be(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && We(e, a, i), i;
};
let g = class extends m {
  constructor() {
    super(...arguments), this.msg = "", this.charts = [], this.stocks = [], this.stocksWidget = [], this.graphs = [], this.relatedQuestions = [], this.chartSelected = this.charts[0] || void 0, this.mapChart = { data: [] }, this.graphPeriod = ue.DAY, this.collapsedSections = /* @__PURE__ */ new Map();
  }
  firstUpdated() {
    var t;
    this.chartSelected = ((t = this.charts) == null ? void 0 : t[0]) ?? void 0, this.updateChartData();
  }
  getGraphType(t) {
    switch (t == null ? void 0 : t.type) {
      case "heatmap":
        return "heatmap";
      case "scatterplot":
        return "scatterplot";
      case "bar":
        return "bar";
      default:
        return null;
    }
  }
  get graphType() {
    return this.getGraphType(this.graphs[0]);
  }
  updateChartData() {
    var t, e;
    if (this.chartSelected) {
      const a = (e = (t = this.chartSelected) == null ? void 0 : t.data) == null ? void 0 : e.map((r) => {
        var i, s, n, ae, re;
        return {
          time: new Date(r == null ? void 0 : r.dateTime).getTime() / 1e3,
          value: ((i = r == null ? void 0 : r.close) == null ? void 0 : i.amount) ?? 0,
          close: (s = r == null ? void 0 : r.close) == null ? void 0 : s.amount,
          open: (n = r == null ? void 0 : r.open) == null ? void 0 : n.amount,
          high: (ae = r == null ? void 0 : r.high) == null ? void 0 : ae.amount,
          low: (re = r == null ? void 0 : r.low) == null ? void 0 : re.amount,
          volume: r == null ? void 0 : r.volume
        };
      });
      this.mapChart = { data: a };
    }
  }
  handleClickTab(t) {
    const e = t.detail;
    this.chartSelected = this.charts.find((a) => a.ticker === e), this.updateChartData();
  }
  renderHeatMap() {
    return c`
      <ht-heat-map-chart
        .value=${this.graphs[0].data[0].value}
        .text=${this.graphs[0].companyName}
      ></ht-heat-map-chart>
    `;
  }
  renderScatterPlot() {
    return c`
      <ht-scatter-plot-chart
        .data=${this.graphs[0].data}
        .highlightCompany=${this.graphs[0].companyName}
        .labels=${[
      l.translate("chat.scatterPlot.axis1"),
      l.translate("chat.scatterPlot.axis2"),
      l.translate("chat.scatterPlot.axis3"),
      l.translate("chat.scatterPlot.axis4")
    ]}
        style="width: 85%; --scatter-highlight-color: var(--strokePrimaryInitial); --scatter-point-color: var(--strokeNeutralStrongInitial);"
      ></ht-scatter-plot-chart>
    `;
  }
  renderBarChart() {
    return c`
      <ht-bar-chart
        .data=${this.graphs[0].data}
        minY="-100"
        maxY="100"
        style="height: 314px; --axis-color: var(--textNeutralStrong); --background-color: var(--surfaceCanvasSecondaryInitial);"
      ></ht-bar-chart>
    `;
  }
  printGraph() {
    var t;
    if ((t = this.graphs) != null && t.length) {
      if (this.graphType === "heatmap")
        return this.renderHeatMap();
      if (this.graphType === "scatterplot")
        return this.renderScatterPlot();
      if (this.graphType === "bar")
        return this.renderBarChart();
    }
    return null;
  }
  toggleCollapse(t) {
    const e = this.collapsedSections.get(t) ?? !1;
    this.collapsedSections.set(t, !e), this.requestUpdate();
  }
  renderGraphExtras() {
    var e, a;
    if (!((e = this.relatedQuestions) != null && e.length)) return h;
    const t = (r = []) => c`
        ${r.map(
      (i) => c`
            <ask-finny-card
              class="card"
              description=${i}
              icon="plus"
            ></ask-finny-card>
          `
    )}
      `;
    return c`
      ${(a = this.relatedQuestions) == null ? void 0 : a.map((r, i) => {
      const s = r.collapse, n = this.collapsedSections.get(i) ?? !1;
      return c`
          <div class="other-questions">
            <div
              class="other-questions-title"
              @click=${() => s && this.toggleCollapse(i)}
              style="cursor: ${s ? "pointer" : "default"}"
            >
              <ht-text
                .text="${r.title}"
                preset="paragraph2"
                color="primary"
              ></ht-text>
              ${s ? c`<chevron-left-icon
                    size="24"
                    color="iconNeutralStrong"
                    class=${n ? "open" : "closed"}
                  ></chevron-left-icon>` : h}
            </div>

            ${!s || n ? c`
                  <div class="other-cards">
                    ${t(r.questions)}
                  </div>
                ` : h}
          </div>
        `;
    })}
    `;
  }
  render() {
    var t, e, a;
    return c`
      <div class="chatbot-engine">
        <ht-markdown
          .content=${this.msg}
          .chart=${this.printGraph()}
          .sanitize=${!0}
        ></ht-markdown>
        ${this.renderGraphExtras()}
        ${this.chartSelected ? c`
              <ht-tab-bar
                .tabs=${this.charts.map((r) => ({
      id: r.ticker,
      title: r.ticker
    }))}
                .activeTab=${(t = this.chartSelected) == null ? void 0 : t.ticker}
                @tab-click=${this.handleClickTab}
              ></ht-tab-bar>
              <ht-trading-view-simple-chart
                .loading=${!1}
                .data=${this.mapChart}
                .onPeriodChange=${(r) => this.graphPeriod = r.detail}
                .selectedPeriod=${this.graphPeriod}
                .showControls=${!1}
                chartHeight="300"
              >
              </ht-trading-view-simple-chart>
            ` : h}
        <div class="chatbot-engine__assets">
          ${((e = this.stocks) == null ? void 0 : e.map(
      (r) => c`<chatbot-asset .asset=${r}></chatbot-asset>`
    )) || h}
        </div>
        <div class="chatbot-engine__assets-small">
          ${((a = this.stocksWidget) == null ? void 0 : a.map(
      (r) => c`<chatbot-asset
                .asset=${r}
                small
              ></chatbot-asset>`
    )) || h}
        </div>
      </div>
    `;
  }
};
g.styles = d`
    ${p(ze)}
  `;
f([
  o({ type: String })
], g.prototype, "msg", 2);
f([
  o({ type: Array })
], g.prototype, "charts", 2);
f([
  o({ type: Array })
], g.prototype, "stocks", 2);
f([
  o({ type: Array })
], g.prototype, "stocksWidget", 2);
f([
  o({ type: Array })
], g.prototype, "graphs", 2);
f([
  o({ type: Array })
], g.prototype, "relatedQuestions", 2);
f([
  _()
], g.prototype, "chartSelected", 2);
f([
  _()
], g.prototype, "mapChart", 2);
f([
  _()
], g.prototype, "graphPeriod", 2);
g = f([
  u("chatbot-engine")
], g);
const je = d`.chatbot-msg-from-chatbot__feedback{display:flex;gap:var(--spacingSmaller);margin-top:var(--spacingSmaller)}`;
var b = /* @__PURE__ */ ((t) => (t[t.none = 0] = "none", t[t.like = 1] = "like", t[t.dislike = 2] = "dislike", t))(b || {}), Ve = Object.defineProperty, Ue = Object.getOwnPropertyDescriptor, se = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? Ue(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && Ve(e, a, i), i;
};
let V = class extends J {
  constructor() {
    super(...arguments), this.sentence = {
      id: "",
      msg: "",
      isFromUser: !1,
      date: 0,
      feedback: null
    };
  }
  handleFeedbackClick(t) {
    this.sentence.id && this.dispatchEvent(
      new CustomEvent("feedback", {
        detail: {
          id: this.sentence.id,
          feedback: t
        }
      })
    );
  }
  handleDislikeClick() {
    if (this.sentence.feedback === b.dislike)
      return this.handleFeedbackClick(b.none);
    this.handleFeedbackClick(b.dislike);
  }
  handleLikeClick() {
    if (this.sentence.feedback === b.like)
      return this.handleFeedbackClick(b.none);
    this.handleFeedbackClick(b.like);
  }
  render() {
    return S`
      <msg-wrapper>
        <chatbot-engine
          .msg=${this.sentence.msg}
          .charts=${this.sentence.charts}
          .stocks=${this.sentence.stocks}
          .stocksWidget=${this.sentence.stocksWidget}
          .graphs=${this.sentence.graphs}
          .relatedQuestions=${this.sentence.relatedQuestions}
        ></chatbot-engine>
        <div class="chatbot-msg-from-chatbot__feedback">
          <div
            data-testid="feedback-dislike"
            @click=${this.handleDislikeClick}
            aria-hidden="true"
            role="button"
          >
            ${this.sentence.feedback === b.dislike ? S`<thumb-down-filled-icon
                  color="negative"
                ></thumb-down-filled-icon>` : S`<thumb-down-icon color="negative"></thumb-down-icon>`}
          </div>

          <div
            data-testid="feedback-like"
            @click=${this.handleLikeClick}
            aria-hidden="true"
            role="button"
          >
            ${this.sentence.feedback === b.like ? S`<thumb-up-filled-icon
                  color="positive"
                ></thumb-up-filled-icon>` : S`<thumb-up-icon color="positive"></thumb-up-icon>`}
          </div>
        </div>
      </msg-wrapper>
    `;
  }
};
V.styles = d`
    ${p(je)}
  `;
se([
  o({ type: Object })
], V.prototype, "sentence", 2);
V = se([
  u("msg-from-chatbot")
], V);
const Qe = d`.error-block{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:var(--spacingSmaller);padding:var(--spacingEnormous) 0}.error-block__subtitle{width:70%}`;
var Ge = Object.defineProperty, Ke = Object.getOwnPropertyDescriptor, te = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? Ke(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && Ge(e, a, i), i;
};
let R = class extends m {
  constructor() {
    super(...arguments), this.errorMessage = "", this.errorSubtitle = "";
  }
  onReload() {
    this.dispatchEvent(new CustomEvent("reload"));
  }
  render() {
    return c`
      <div class="error-block">
        <ht-button
          auto-width
          button-type="link"
          shape="square"
          @click=${this.onReload}
        >
          <reload-icon size="52" color="iconPrimaryInitial"></reload-icon>
        </ht-button>
        <ht-text
          .text=${this.errorMessage}
          preset="headline2"
          align="center"
        ></ht-text>
        <div class="error-block__subtitle">
          <ht-text
            .text=${this.errorSubtitle}
            preset="paragraph2"
            align="center"
            color="secondary"
          ></ht-text>
        </div>
      </div>
    `;
  }
};
R.styles = d`
    ${p(Qe)}
  `;
te([
  o({ type: String })
], R.prototype, "errorMessage", 2);
te([
  o({ type: String })
], R.prototype, "errorSubtitle", 2);
R = te([
  u("error-block")
], R);
const Ye = d`.chatbot-content__message,.chatbot-content__loading{margin:var(--spacingSmaller) 0}.chatbot-content__loading-container{display:inline-flex;gap:var(--spacingTiny);align-items:center}`;
var Je = Object.defineProperty, Xe = Object.getOwnPropertyDescriptor, K = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? Xe(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && Je(e, a, i), i;
};
let L = class extends m {
  constructor() {
    super(...arguments), this.conversation = [], this.error = null, this.loading = !1;
  }
  resetChat() {
    this.dispatchEvent(new CustomEvent("reset-chat"));
  }
  handleFeedback(t) {
    const { id: e, feedback: a } = t.detail;
    this.dispatchEvent(
      new CustomEvent("msg-feedback", { detail: { id: e, feedback: a } })
    );
  }
  render() {
    var t, e;
    return c`
      <div class="chatbot-content">
        ${!this.error && ((t = this.conversation) == null ? void 0 : t.length) > 0 ? this.conversation.map(
      (a, r) => {
        var i;
        return c`
                <div class="chatbot-content__message">
                  ${a.isFromUser ? c`<msg-from-user
                        .sentence=${a}
                        .isLastMessage=${r === ((i = this.conversation) == null ? void 0 : i.length) - 1}
                      ></msg-from-user>` : c`<msg-from-chatbot
                        .sentence=${a}
                        @feedback=${this.handleFeedback}
                      ></msg-from-chatbot>`}
                </div>
              `;
      }
    ) : h}
        ${this.loading && ((e = this.conversation) == null ? void 0 : e.length) > 1 ? c`
              <div class="chatbot-content__loading">
                <msg-wrapper>
                  <div class="chatbot-content__loading-container">
                    <spinner-icon color="iconNeutralSoft"></spinner-icon>
                    <ht-text
                      preset="paragraph2"
                      text=${l.translate("chat.loading")}
                    ></ht-text>
                  </div>
                </msg-wrapper>
              </div>
            ` : h}
        ${this.error ? c`<error-block @reload=${this.resetChat}></error-block>` : h}
      </div>
    `;
  }
};
L.styles = d`
    ${p(Ye)}
  `;
K([
  o({ type: Array })
], L.prototype, "conversation", 2);
K([
  o({ type: String })
], L.prototype, "error", 2);
K([
  o({ type: Boolean })
], L.prototype, "loading", 2);
L = K([
  u("chatbot-content")
], L);
var ra = d``;
function ne(t) {
  var e, a, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var i = t.length;
    for (e = 0; e < i; e++) t[e] && (a = ne(t[e])) && (r && (r += " "), r += a);
  } else for (a in t) t[a] && (r && (r += " "), r += a);
  return r;
}
function oe() {
  for (var t, e, a = 0, r = "", i = arguments.length; a < i; a++) (t = arguments[a]) && (e = ne(t)) && (r && (r += " "), r += e);
  return r;
}
const Ze = d`.prompt-card{display:flex;align-items:center;justify-content:center;cursor:pointer;border-radius:var(--borderRadiusTiny);padding:var(--spacingTiny);height:100%;text-overflow:ellipsis}.prompt-card.--bordered{border:1px solid var(--strokeNeutralSoftInitial)}.prompt-card.--filled{background-color:var(--surfaceCanvasSecondaryInitial)}.prompt-card:hover{background-color:var(--surfaceCanvasTertiaryInitial);transition:all var(--transitionNormal)}.prompt-card__text{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}`;
var et = Object.defineProperty, tt = Object.getOwnPropertyDescriptor, W = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? tt(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && et(e, a, i), i;
};
let I = class extends m {
  constructor() {
    super(...arguments), this.title = "", this.theme = "transparent", this.class = "", this.preset = "paragraph1";
  }
  get promptCardClasses() {
    return oe({
      "prompt-card": !0,
      "--filled": this.theme === "filled",
      "--bordered": this.theme === "transparent",
      [this.class]: !!this.class
    });
  }
  render() {
    return c`
      <div
        class="${this.promptCardClasses}"
        role="button"
        tabindex="0"
        aria-hidden="false"
        data-testid="prompt-${this.title}"
      >
        <ht-text
          .text="${this.title}"
          .preset="${this.preset}"
          class="prompt-card__text"
          color="primary"
        ></ht-text>
      </div>
    `;
  }
};
I.styles = d`
    ${p(Ze)}
  `;
W([
  o({ type: String })
], I.prototype, "title", 2);
W([
  o({ type: String })
], I.prototype, "theme", 2);
W([
  o({ type: String, reflect: !1 })
], I.prototype, "class", 2);
W([
  o({ type: String })
], I.prototype, "preset", 2);
I = W([
  u("prompt-card")
], I);
const at = d`.chatbot-cta{display:flex;align-items:center;justify-content:center;cursor:pointer;border-radius:var(--borderRadiusTiny);padding:var(--spacingTiny);height:100%}.chatbot-cta.orange{border:1px solid var(--iconPrimaryInitial)}.chatbot-cta:hover{background-color:var(--surfaceCanvasTertiaryInitial);transition:all var(--transitionNormal)}`;
var rt = Object.defineProperty, it = Object.getOwnPropertyDescriptor, Y = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? it(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && rt(e, a, i), i;
};
let E = class extends J {
  constructor() {
    super(...arguments), this.title = "", this.theme = "filled", this.className = "";
  }
  get ctaClasses() {
    return oe({
      "chatbot-cta orange": !0,
      "--filled": this.theme === "filled",
      "--bordered": this.theme === "transparent",
      [this.className]: !!this.className
    });
  }
  render() {
    return S`
      <div class="${this.ctaClasses}" role="button" aria-hidden="true">
        <ht-text preset="paragraph2" color="iconPrimaryInitial">
          ${this.title}
        </ht-text>
      </div>
    `;
  }
};
E.styles = ie`
    ${p(at)}
  `;
Y([
  o({ type: String })
], E.prototype, "title", 2);
Y([
  o({ type: String })
], E.prototype, "theme", 2);
Y([
  o({ type: String })
], E.prototype, "className", 2);
E = Y([
  u("chatbot-cta")
], E);
const st = d`:host{display:block;container-type:inline-size}.chatbot-questions__cards{display:flex;flex-direction:row;gap:var(--spacingSmaller);height:calc(var(--spacingSmall) * 4);list-style:none;padding:0;margin:0}.chatbot-questions__card{flex:3 1 0}.chatbot-questions__more{width:calc(var(--spacingSmall) * 5)}.chatbot-questions .bordered{border:1px solid var(--strokeNeutralSoftInitial);height:calc(var(--spacingSmall) * 4)}.chatbot-questions .bordered.orange{border-color:var(--strokePrimaryInitial)}@container (max-width: 800px){.chatbot-questions__cards{flex-direction:column;align-items:flex-start;height:auto}.chatbot-questions__card{display:none}.chatbot-questions__cards.expanded .chatbot-questions__card{display:block;width:100%;flex:none}.chatbot-questions__more{align-self:flex-end}}`;
var nt = Object.defineProperty, ot = Object.getOwnPropertyDescriptor, B = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? ot(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && nt(e, a, i), i;
};
let $ = class extends m {
  constructor() {
    super(...arguments), this.theme = "transparent", this.questions = [], this.ctaLabel = "", this.expanded = !1, this.onClickPrompt = (t) => {
      this.dispatchEvent(
        new CustomEvent("prompt-clicked", {
          detail: {
            description: t
          }
        })
      );
    }, this.onClickCta = () => {
      this.dispatchEvent(new CustomEvent("cta-clicked"));
    };
  }
  render() {
    return c`
      <div class="chatbot-questions__cards ${this.expanded ? "expanded" : ""}">
        ${this.questions.map(
      ({ description: t }) => c`
            <div class="chatbot-questions__card">
              <prompt-card
                .title=${t}
                .theme=${this.theme}
                .preset=${"paragraph2"}
                @click=${() => this.onClickPrompt(t)}
              ></prompt-card>
            </div>
          `
    )}
        <chatbot-cta
          className="chatbot-questions__more"
          @click=${this.onClickCta}
          .title=${this.ctaLabel}
          .theme=${this.theme}
        ></chatbot-cta>
      </div>
    `;
  }
};
$.styles = d`
    ${p(st)}
  `;
B([
  o({ type: String })
], $.prototype, "theme", 2);
B([
  o({ type: Array })
], $.prototype, "questions", 2);
B([
  o({ type: String, attribute: "cta-label" })
], $.prototype, "ctaLabel", 2);
B([
  o({ type: Boolean, reflect: !0 })
], $.prototype, "expanded", 2);
$ = B([
  u("chatbot-questions")
], $);
class lt {
  constructor(e) {
    this.client = {
      name: "heytrade",
      type: "web",
      version: "4.1.0"
    }, this.chatService = new pe({
      client: this.client,
      ...e
    });
  }
  async createThread() {
    const e = await this.chatService.createThread();
    if (!e.data)
      throw new Error("No data returned from chat service");
    return e.data;
  }
  async sendMessage(e, a) {
    return (await this.chatService.chat({
      threadId: e,
      text: a
    })).data;
  }
  async sendFeedback(e, a, r) {
    return (await this.chatService.sendFeedback(e, a, {
      status: r
    })).data;
  }
  async acceptDisclaimerNote() {
    await this.chatService.acceptTerms();
  }
  async getDisclaimerNote(e) {
    try {
      return !!await this.chatService.checkTerms(e);
    } catch {
      return !1;
    }
  }
}
class ct {
  constructor(e, a, r) {
    this.host = null, this.listeners = /* @__PURE__ */ new Set(), this._conversation = [], this._error = null, this._id = null, this._loading = !0, this._isLegalAccepted = !1, this._isLegalLoading = !0, this.customerId = "", this._isReady = !1, this.host = e, this.customerId = a;
    try {
      if (!(r != null && r.apiKey) || !(r != null && r.baseURL) || !(r != null && r.authToken))
        throw new Error("Configuration is incomplete");
      this.chatService = new lt(r), this.host.addController(this);
    } catch (i) {
      this._error = i instanceof Error ? i.message : String(i), this._loading = !1;
    }
  }
  hostConnected() {
    try {
      this.customerId && this.checkPermission(), this.fetchThreadId();
    } catch (e) {
      this.handleError(e);
    }
  }
  handleError(e) {
    this._error = e instanceof Error ? e.message : String(e), this._loading = !1, this.notify("error"), this.notify("loading");
  }
  subscribe(e) {
    return this.listeners.add(e), () => this.listeners.delete(e);
  }
  notify(e) {
    this.listeners.forEach(
      (a) => a(e, this == null ? void 0 : this[e])
    );
  }
  async checkPermission() {
    var e;
    this.isLegalLoading = !0;
    try {
      const a = await ((e = this.chatService) == null ? void 0 : e.getDisclaimerNote(
        this.customerId
      ));
      this.isLegalAccepted = a ?? !1;
    } catch {
      this.isLegalAccepted = !1;
    }
    this.isLegalLoading = !1, this.notify("isLegalAccepted"), this.notify("isLegalLoading");
  }
  async fetchThreadId() {
    this.loading = !0, this.error = null, this.isReady = !1, this.notify("loading"), this.notify("error"), this.notify("isReady");
    try {
      const e = await this.chatService.createThread();
      this.id = e.id, this.loading = !1, this.isReady = !0, this._conversation = [
        {
          id: e.id,
          msg: l.translate("chat.conversation.initialMessage"),
          charts: [],
          stocks: [],
          stocksWidget: [],
          graphs: [],
          relatedQuestions: [
            {
              title: "",
              questions: [
                l.translate("chat.conversation.initialQuestions.question1"),
                l.translate("chat.conversation.initialQuestions.question2"),
                l.translate("chat.conversation.initialQuestions.question3"),
                l.translate("chat.conversation.initialQuestions.question4")
              ],
              collapse: !1
            }
          ],
          date: (/* @__PURE__ */ new Date()).getTime(),
          isFromUser: !1,
          feedback: null
        }
      ], this.notify("isReady"), this.notify("loading"), this.notify("conversation");
    } catch (e) {
      this.error = e, this.loading = !1, this.isReady = !1, this.notify("isReady"), this.notify("loading"), this.notify("error");
    }
  }
  async sendChatRequest(e) {
    if (!this.id)
      throw new Error("Thread ID is not set");
    this.loading = !0, this.error = null, this.notify("loading");
    try {
      const a = await this.chatService.sendMessage(this.id, e);
      this._conversation = [
        ...this._conversation,
        {
          id: a == null ? void 0 : a.id,
          msg: a == null ? void 0 : a.msg,
          charts: a == null ? void 0 : a.charts,
          stocks: a == null ? void 0 : a.stocks,
          stocksWidget: a == null ? void 0 : a.stocksWidget,
          graphs: a == null ? void 0 : a.graphs,
          relatedQuestions: a == null ? void 0 : a.relatedQuestions,
          date: new Date(a == null ? void 0 : a.date).getTime(),
          isFromUser: !1,
          feedback: null
        }
      ], this.loading = !1;
    } catch (a) {
      this.error = a instanceof Error ? a.message : String(a), this.loading = !1;
    }
    this.notify("loading"), this.notify("error"), this.notify("conversation");
  }
  addConversation(e) {
    this._conversation = [
      ...this._conversation,
      {
        id: this._conversation.length.toString(),
        msg: e,
        date: (/* @__PURE__ */ new Date()).getTime(),
        isFromUser: !0,
        feedback: null
      }
    ], this.notify("conversation");
  }
  async sendMsgFeedback(e, a) {
    if (!this.id)
      throw new Error("Thread ID is not set");
    await this.chatService.sendFeedback(this.id, e, a), this._conversation = this._conversation.map((r) => r.id === e ? { ...r, feedback: a } : r), this.notify("conversation");
  }
  resetErrorMessage() {
    this._conversation = this._conversation.map((e) => ({
      ...e,
      error: void 0
    })), this.notify("conversation");
  }
  clearConversation() {
    this._conversation = [], this.id = null, this.error = null, this.loading = !0, this.isLegalAccepted = !0, this.isReady = !1, this.notify("conversation");
  }
  async acceptDisclaimerNote() {
    try {
      await this.chatService.acceptDisclaimerNote(), this.isLegalAccepted = !0, this.isLegalLoading = !1;
    } catch (e) {
      this.error = e, this.isLegalLoading = !1;
    }
    this.notify("isLegalAccepted"), this.notify("isLegalLoading");
  }
  async getDisclaimerNote(e) {
    try {
      this.isLegalLoading = !0, await this.chatService.getDisclaimerNote(e), this.isLegalAccepted = !0, this.isLegalLoading = !1;
    } catch (a) {
      this.error = a, this.isLegalLoading = !1;
    }
    this.notify("isLegalLoading");
  }
  sendMessage(e, a = !0) {
    a ? this.addConversation(e) : this.resetErrorMessage(), this.sendChatRequest(e);
  }
  sendFeedback(e, a) {
    this.sendMsgFeedback(e, a);
  }
  get isReady() {
    return this._isReady;
  }
  set isReady(e) {
    this._isReady = e;
  }
  get conversation() {
    return this._conversation;
  }
  set conversation(e) {
    this._conversation = e;
  }
  get error() {
    return this._error;
  }
  set error(e) {
    this._error = e;
  }
  get id() {
    return this._id;
  }
  set id(e) {
    this._id = e;
  }
  get loading() {
    return this._loading;
  }
  set loading(e) {
    this._loading = e;
  }
  get isLegalAccepted() {
    return this._isLegalAccepted;
  }
  set isLegalAccepted(e) {
    this._isLegalAccepted = e;
  }
  get isLegalLoading() {
    return this._isLegalLoading;
  }
  set isLegalLoading(e) {
    this._isLegalLoading = e;
  }
  hostDisconnected() {
    this.clearConversation();
  }
}
const dt = d`:root{--bpExtraSmall: 480px;--bpSmall: 768px;--bpMedium: 1024px;--bpLarge: 1280px;--bpExtraLarge: 1366px;--bpSmallHuge: 1600px;--bpHuge: 1920px;--largeWidth: 1240px;--mainWidth: 972px;--smallWidth: 720px;--smallerWidth: 580px;--tinyWidth: 343px;--tinyMedium: 200px;--carouselSmallHeight: 10.5rem;--carouselSmallWidth: 14rem;--carouselMediumHeight: 13.125rem;--carouselMediumWidth: 17.5rem;--ff900: "Inter900", sans-serif;--ff800: "Inter800", sans-serif;--ff700: "Inter700", sans-serif;--ff600: "Inter600", sans-serif;--ff500: "Inter500", sans-serif;--ff400: "Inter400", sans-serif;--ff300: "Inter300", sans-serif;--ff200: "Inter200", sans-serif;--ff100: "Inter100", sans-serif;--fontSizeExtraSmall: .625rem;--fontSizeSmall: .75rem;--fontSizeExtraBase: .875rem;--fontSizeBase: 1rem;--fontSizeMedium: 1.125rem;--fontSizeLarge: 1.25rem;--fontSizeExtraLarge: 1.5rem;--fontSizeHugeMinus: 1.75rem;--fontSizeHuge: 2.25rem;--fontSizeMassive: 3rem;--lineHeightExtraSmall: .75rem;--lineHeightSmall: 1rem;--lineHeightExtraBase: 1.25rem;--lineHeightBase: 1.375rem;--lineHeightExtraMedium: 1.5rem;--lineHeightMedium: 1.625rem;--lineHeightLarge: 1.75rem;--lineHeightExtraLarge: 2rem;--lineHeightHuge: 3rem;--lineHeightMassive: 3.875rem;--zIndexBelow: -1;--zIndexAbove: 1;--zIndexModal1: 10;--zIndexModal2: 25;--zIndexModal3: 50;--transitionUltraFast: .15s;--transitionFast: .25s;--transitionNormal: .5s;--transitionSlow: .75s;--headerHeight: 3.5rem;--sidebarWidth: 5.5rem;--footerHeight: 3.5rem;--paddingHorizontal: 1.5rem;--paddingHorizontalBigScreen: 1.375rem;--spacingNone: 0rem;--spacingExtraTiny: .125rem;--spacingTinyMinus: .25rem;--spacingTinyMedium: .375rem;--spacingTiny: .5rem;--spacingTinyPlus: .625rem;--spacingSmallerMinus: .75rem;--spacingSmaller: 1rem;--spacingSmallerPlus: 1.125rem;--spacingSmallerSuper: 1.25rem;--spacingSmallMinus: 1.375rem;--spacingSmall: 1.5rem;--spacingSmallPlus: 1.75rem;--spacingMedium: 2rem;--spacingMediumIntermediate: 2.125rem;--spacingMediumIntermediatePlus: 2.375rem;--spacingMediumPlus: 2.5rem;--spacingLargeMinus: 2.625rem;--spacingLarge: 3rem;--spacingHuge: 3.5rem;--spacingMassive: 4rem;--spacingMassivePlus: 4.25rem;--spacingEnormousMinus: 4.5rem;--spacingEnormous: 5rem;--borderRadiusNone: 0;--borderRadiusTiny: .125rem;--borderRadiusTinyPlus: .25rem;--borderRadiusSmall: .375rem;--borderRadiusSmallPlus: .5rem;--borderRadiusMedium: .625rem;--borderRadiusMediumPlus: .75rem;--borderRadiusLarge: .875rem;--borderRadiusHuge: 1.125rem;--borderRadiusMassive: 1.375rem;--borderRadiusFull: 100%;--mainScrollbarWidth: 13px;--customModalScrollbarWidth: 5px;--cellHorizontalPadding: 1.0625rem;--readOnlyExtraVerticalSize: 8px;--fieldBorderRadius: 4px;--fieldSizeSmall: 40px;--fieldSizeNormal: 48px;--fieldSizeLarge: 60px;--fieldSizeHuge: 80px;--labelFontSize: var(--fontSizeSmall)}:host{display:block;height:100%;overflow:hidden;white-space:normal}.chatbot-layout{display:grid;grid-template-rows:auto 1fr auto;height:100%;overflow:hidden}.chatbot-layout__header{display:flex;justify-content:space-between;align-items:center;margin-bottom:var(--spacingMedium);flex:0 1 auto}.chatbot-layout__header-icons{display:flex;align-items:center;gap:var(--spacingExtraTiny)}.chatbot-layout__content{height:100%;overflow-y:scroll;scrollbar-width:none;-ms-overflow-style:none}.chatbot-layout__content::-webkit-scrollbar{display:none}.chatbot-layout__input-section{padding:var(--spacingSmall) 0}.chatbot-layout__questions{margin-top:var(--spacingSmall)}`;
var ut = Object.defineProperty, pt = Object.getOwnPropertyDescriptor, q = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? pt(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && ut(e, a, i), i;
};
let P = class extends m {
  constructor() {
    super(...arguments), this.activeTab = "chat", this.questions = [], this.customerId = "", this.auth = null, this.defaultPrompt = null, this.unsubscribe = () => {
    }, this.chatContentRef = C(), this.modalRef = C(), this.modalLegalRef = C(), this.scrollPosition = 0, this.chatController = null;
  }
  // Lifecycle methods
  connectedCallback() {
    super.connectedCallback(), this.addEventListener(
      "askFinnyCardClicked",
      this._handleAskFynnyCardClicked
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener(
      "askFinnyCardClicked",
      this._handleAskFynnyCardClicked
    ), this.unsubscribe();
  }
  updated(t) {
    this._handleAuthAndCustomerIdChanges(t), this._handleActiveTabChange(t);
  }
  // Private methods for lifecycle hooks
  _handleAskFynnyCardClicked(t) {
    const a = t.detail;
    a != null && a.description && this.send(a.description);
  }
  _checkLegalAcceptance() {
    var t, e;
    if (!((t = this.chatController) != null && t.isLegalAccepted)) {
      this.openLegalModal();
      return;
    }
    (e = this.modalLegalRef.value) == null || e.closeModal();
  }
  handleDefaultPrompt() {
    this.defaultPrompt && (this.send(this.defaultPrompt), this.defaultPrompt = null);
  }
  _handleChatReady() {
    this.dispatchEvent(
      new CustomEvent("ChatReady", {
        bubbles: !0,
        composed: !0
      })
    );
  }
  _handleAuthAndCustomerIdChanges(t) {
    var e;
    if (t.has("auth") || t.has("customerId")) {
      const a = ((e = this.auth) == null ? void 0 : e.authToken) !== this._lastAuthToken;
      if (!this.auth || !this.customerId || this.chatController && !a)
        return;
      this._lastAuthToken = this.auth.authToken, this._initializeChatController(this.customerId, this.auth);
    }
  }
  _initializeChatController(t, e) {
    this.chatController = new ct(this, t, e), this.unsubscribe = this.chatController.subscribe(
      (a, r) => {
        a === "conversation" && this.scrollToLastMessage(), a === "isLegalLoading" && this._checkLegalAcceptance(), a === "isLegalAccepted" && r === !0 && this.defaultPrompt && this.handleDefaultPrompt(), a === "isReady" && r === !0 && this._handleChatReady(), this.requestUpdate();
      }
    );
  }
  _handleActiveTabChange(t) {
    t.has("activeTab") && this.activeTab === "chat" && this._restoreScrollPosition();
  }
  _restoreScrollPosition() {
    requestAnimationFrame(() => {
      var e;
      const t = (e = this.shadowRoot) == null ? void 0 : e.querySelector(".chatbot-layout__content");
      t && (t.scrollTop = this.scrollPosition);
    });
  }
  // UI event handlers
  setTab(t) {
    this.activeTab = t;
  }
  send(t) {
    t && this.chatController && this.chatController.sendMessage(t.trim());
  }
  handleSend(t) {
    var a;
    const e = (a = t.detail) == null ? void 0 : a.value;
    this.send(e);
  }
  handleCancel() {
    this.dispatchEvent(new CustomEvent("cancel"));
  }
  handlePromptClick(t) {
    const { description: e } = t.detail;
    e && this.send(e);
  }
  handleCtaClicked(t) {
    this.setTab(t);
  }
  handleMsgFeedback(t) {
    const { id: e, feedback: a } = t.detail;
    this.chatController && this.chatController.sendFeedback(e, a);
  }
  // Public methods
  openModal() {
    const t = this.modalRef.value;
    typeof (t == null ? void 0 : t.showModal) == "function" && (t == null || t.showModal());
  }
  openFAQ() {
    this.dispatchEvent(
      new CustomEvent("ClickFaq", {
        composed: !0,
        bubbles: !0
      })
    );
  }
  openLegalModal() {
    const t = this.modalLegalRef.value;
    typeof (t == null ? void 0 : t.showModal) == "function" && (t == null || t.showModal());
  }
  handleLegalAccept() {
    this.chatController && this.chatController.acceptDisclaimerNote();
  }
  scrollToLastMessage() {
    requestAnimationFrame(() => {
      var e;
      const t = this.chatContentRef.value;
      if (t) {
        const a = (e = t.shadowRoot) == null ? void 0 : e.querySelectorAll(
          ".chatbot-content__message"
        ), r = a == null ? void 0 : a[a.length - 1];
        r == null || r.scrollIntoView({ behavior: "smooth" }), this.scrollPosition = (r == null ? void 0 : r.offsetTop) ?? 0;
      }
    });
  }
  _renderChatTab() {
    return c`
      <div class="chatbot-layout">
        ${this._renderHeader()} ${this._renderContent()}
        ${this._renderInputSection()}
      </div>
      ${this._renderModals()}
    `;
  }
  _renderHeader() {
    return c`
      <div class="chatbot-layout__header">
        <ht-text preset="headline1"> ${l.translate("chat.title")} </ht-text>
        <div
          class="chatbot-layout__header-icons"
          role="navigation"
          aria-label="Header icons"
        >
          <ht-button
            button-type="link"
            auto-width
            aria-label="Legal information"
            @click=${this.openLegalModal}
          >
            <legal-icon
              size="24"
              color="iconNeutralStrong"
              aria-hidden="true"
            ></legal-icon>
          </ht-button>
          <ht-button
            button-type="link"
            auto-width
            @click=${this.openFAQ}
            aria-label="Frequently Asked Questions"
          >
            <faq-icon
              size="24"
              color="iconNeutralStrong"
              aria-hidden="true"
            ></faq-icon>
          </ht-button>
          <ht-button
            button-type="link"
            auto-width
            @click=${this.openModal}
            aria-label="Share"
          >
            <share-icon
              size="24"
              color="iconNeutralStrong"
              aria-hidden="true"
            ></share-icon>
          </ht-button>
        </div>
      </div>
    `;
  }
  _renderContent() {
    var t, e, a;
    return c`
      <div class="chatbot-layout__content">
        <chatbot-content
          ${w(this.chatContentRef)}
          @msg-feedback=${this.handleMsgFeedback}
          .conversation=${((t = this.chatController) == null ? void 0 : t.conversation) ?? []}
          .loading=${((e = this.chatController) == null ? void 0 : e.loading) ?? !1}
          .error=${((a = this.chatController) == null ? void 0 : a.error) ?? null}
        ></chatbot-content>
      </div>
    `;
  }
  _renderInputSection() {
    var t;
    return c`
      <div class="chatbot-layout__input-section">
        <chatbot-input
          .isLoading=${((t = this.chatController) == null ? void 0 : t.loading) ?? !1}
          @send=${this.handleSend}
          @cancel=${this.handleCancel}
          aria-label="Chat input"
          placeholder=${l.translate("chat.input.placeholder")}
        ></chatbot-input>
        <chatbot-questions
          cta-label=${l.translate("chat.prompts.more")}
          class="chatbot-layout__questions"
          .questions=${this.questions}
          @cta-clicked=${() => this.handleCtaClicked(
      "prompts"
      /* prompts */
    )}
          @prompt-clicked=${this.handlePromptClick}
        ></chatbot-questions>
      </div>
    `;
  }
  _renderModals() {
    return c`
      <modal-share
        ${w(this.modalRef)}
        title=${l.translate("chat.share.title")}
        close-label=${l.translate("chat.share.close")}
      ></modal-share>
      <modal-legal
        ${w(this.modalLegalRef)}
        title=${l.translate("chat.legalDisclaimer.title")}
        close-label=${l.translate("chat.legalDisclaimer.close")}
        faq-href=${l.translate("chat.legalDisclaimer.legalHref")}
        customer-support-href=${l.translate(
      "chat.legalDisclaimer.customerSupportHref"
    )}
        @accept=${this.handleLegalAccept}
      ></modal-legal>
    `;
  }
  _renderPromptsTab() {
    return c`
      <chatbot-questions
        .questions=${this.questions}
        .expanded=${!0}
        cta-label=${l.translate("chat.prompts.hide")}
        @cta-clicked=${() => this.handleCtaClicked(
      "chat"
      /* chat */
    )}
        @prompt-clicked=${(t) => {
      this.handlePromptClick(t), this.setTab(
        "chat"
        /* chat */
      );
    }}
      ></chatbot-questions>
    `;
  }
  // Render methods
  render() {
    return c`
      ${this.activeTab === "chat" ? this._renderChatTab() : h}
      ${this.activeTab === "prompts" ? this._renderPromptsTab() : h}
    `;
  }
};
P.styles = d`
    ${p(dt)}
  `;
q([
  _()
], P.prototype, "activeTab", 2);
q([
  o({ type: Array })
], P.prototype, "questions", 2);
q([
  o({ type: String })
], P.prototype, "customerId", 2);
q([
  o({ type: Object })
], P.prototype, "auth", 2);
q([
  o({ type: String })
], P.prototype, "defaultPrompt", 2);
P = q([
  u("chat-screen")
], P);
const mt = d`:host{display:block;white-space:normal}.ask-finny-about__header{display:flex;justify-content:space-between;padding-bottom:var(--spacingTinyPlus);align-items:flex-start;gap:var(--spacingSmall)}.ask-finny-about__header div{display:flex;align-items:center;gap:var(--spacingTiny);cursor:pointer}.ask-finny-about__cards{display:flex;flex-direction:column;background-color:var(--surfaceCanvasSecondaryInitial);border-radius:var(--borderRadiusSmall)}.ask-finny-about__card{display:flex;flex-direction:column;cursor:pointer;padding:0 var(--spacingSmallMinus)}.ask-finny-about__card:last-child div{border-bottom:none}.ask-finny-about__card:hover{background-color:var(--surfaceCanvasTertiaryInitial);transition:all var(--transitionNormal)}.ask-finny-about__card div{display:flex;border-bottom:1px solid var(--strokeNeutralSoftInitial);padding:var(--spacingSmallMinus) 0}.ask-finny-about__card div chevron-left-icon{margin-left:auto;transform:rotate(180deg);align-items:center}`;
var ht = Object.defineProperty, vt = Object.getOwnPropertyDescriptor, j = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? vt(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && ht(e, a, i), i;
};
let N = class extends m {
  constructor() {
    super(...arguments), this.company = "", this.questions = [];
  }
  connectedCallback() {
    super.connectedCallback();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  dispatchCustomEvent(t, e) {
    this.dispatchEvent(
      new CustomEvent(t, {
        detail: e,
        bubbles: !0,
        composed: !0
      })
    );
  }
  onClickNewChat() {
    this.dispatchCustomEvent("NewChatClicked", {});
  }
  onClickCard(t) {
    this.dispatchCustomEvent("AskFinnyAboutClicked", { description: t });
  }
  render() {
    return c`
      <div class="ask-finny-about">
        <div class="ask-finny-about__header">
          <ht-text preset="paragraph2"
            >${l.translate("askFinnyAbout.title")} ${this.company}</ht-text
          >
          <div
            role="button"
            aria-hidden="false"
            @click=${() => this.onClickNewChat()}
          >
            <ht-text preset="paragraph2" color="iconPrimaryInitial"
              >${l.translate("askFinnyAbout.newChat")}</ht-text
            >
            <chatbot-icon size="22" color="iconPrimaryInitial"></chatbot-icon>
          </div>
        </div>
        <div class="ask-finny-about__cards">
          ${this.questions.map(
      ({ description: t }) => c`
              <div class="ask-finny-about__card">
                <div
                  role="button"
                  tabindex="0"
                  aria-hidden="false"
                  data-testid="prompt-${t}"
                  @click=${() => this.onClickCard(t)}
                >
                  <ht-text
                    .text="${t}"
                    preset="paragraph2"
                    class="prompt-card__text"
                    color="primary"
                  ></ht-text>
                  <chevron-left-icon
                    size="24"
                    color="iconNeutralStrong"
                  ></chevron-left-icon>
                </div>
              </div>
            `
    )}
        </div>
      </div>
    `;
  }
};
N.styles = d`
    ${p(mt)}
  `;
j([
  o({ type: String })
], N.prototype, "company", 2);
j([
  o({ type: Array })
], N.prototype, "questions", 2);
j([
  U({ capture: !0 })
], N.prototype, "onClickNewChat", 1);
j([
  U({ capture: !0 })
], N.prototype, "onClickCard", 1);
N = j([
  u("ask-finny-about")
], N);
const le = d`@media (prefers-color-scheme: dark){:host{--actionPrimaryInitial: var(--primary500);--actionPrimaryHover: var(--primary600);--actionPrimaryPressed: var(--primary700);--actionPrimaryDisabled: var(--neutral300);--actionPrimarySubtleInitial: var(--primary900);--actionPrimarySubtleHover: var(--primary800);--actionPrimarySubtlePressed: var(--primary750);--actionPrimarySubtleDisabled: var(--neutral700);--actionNegativeInitial: var(--destructive900);--actionNegativeHover: var(--destructive800);--actionNegativePressed: var(--destructive700);--actionNegativeDisabled: var(--neutral700);--labelPrimaryInitial: var( --neutral900 );--labelPrimaryDisabled: var(--neutral400);--labelPrimarySubtleInitial: var(--primary500);--labelPrimarySubtleHover: var(--primary400);--labelPrimarySubtlePressed: var(--primary300);--labelPrimarySubtleDisabled: var(--neutral400);--labelPrimarySubtleInactive: var(--neutral300);--labelPrimarySubtleActive: var(--neutral050);--labelNegativeInitial: var(--destructive400);--labelNegativeHover: var(--destructive300);--labelNegativePressed: var(--destructive200);--labelNegativeDisabled: var(--neutral400);--strokeNeutralStrongInitial: var( --neutral300 );--strokeNeutralStrongHover: var( --neutral050 );--strokeNeutralSoftInitial: var(--neutral700);--strokeNeutralSoftHover: var(--neutral600);--strokePrimaryInitial: var(--primary500);--strokePrimaryHover: var(--primary400);--strokePrimarySubtleInitial: var( --primary800 );--strokePrimarySubtleHover: var( --primary750 );--strokeNegativeInitial: var(--destructive400);--strokeNegativeHover: var(--destructive300);--strokePositiveInitial: var(--destructive400);--strokePositiveHover: var(--destructive300);--surfaceCanvasPrimaryInitial: var(--neutral900);--surfaceCanvasPrimaryHover: var(--neutral800);--surfaceCanvasPrimaryPressed: var(--neutral750);--surfaceCanvasSecondaryInitial: var(--neutral800);--surfaceCanvasSecondaryHover: var(--neutral750);--surfaceCanvasSecondaryPressed: var(--neutral700);--surfaceCanvasTertiaryInitial: var(--neutral750);--surfaceCanvasTertiaryHover: var(--neutral700);--surfaceCanvasTertiaryPressed: var(--neutral600);--surfacePrimaryInitial: var(--primary700);--surfacePrimaryHover: var(--primary600);--surfacePrimaryPressed: var(--primary600);--surfacePrimarySubtleInitial: var(--primary900);--surfacePrimarySubtleHover: var(--primary800);--surfacePrimarySubtlePressed: var(--primary750);--surfacePrimaryInvertedInitial: var(--black);--backgroundFixedButton: var(--neutral900);--surfaceSecondaryInitial: var(--secondary800);--surfaceSecondaryHover: var(--secondary700);--surfaceSecondaryPressed: var(--secondary600);--surfaceSecondarySubtleInitial: var(--secondary900);--surfaceSecondarySubtleHover: var(--secondary800);--surfaceSecondarySubtlePressed: var(--secondary750);--surfaceTertiaryInitial: var(--tertiary800);--surfaceTertiaryHover: var(--tertiary700);--surfaceTertiaryPressed: var(--tertiary600);--surfaceTertiarySubtleInitial: var(--tertiary900);--surfaceTertiarySubtleHover: var(--tertiary800);--surfaceTertiarySubtlePressed: var(--tertiary750);--surfacePositiveInitial: var(--success800);--surfacePositiveHover: var(--success700);--surfacePositivePressed: var(--success600);--surfacePositiveSubtleInitial: var(--success900);--surfacePositiveSubtleHover: var(--success800);--surfacePositiveSubtlePressed: var(--success750);--surfaceNegativeInitial: var(--destructive800);--surfaceNegativeHover: var(--destructive700);--surfaceNegativePressed: var(--destructive600);--surfaceNegativeSubtleInitial: var(--destructive900);--surfaceNegativeSubtleHover: var(--destructive800);--surfaceNegativeSubtlePressed: var(--destructive750);--surfaceWarningInitial: var(--warning800);--surfaceWarningHover: var(--warning700);--surfaceWarningPressed: var(--warning600);--surfaceWarningSubtleInitial: var(--warning900);--surfaceWarningSubtleHover: var(--warning800);--surfaceWarningSubtlePressed: var(--warning750);--textNeutralStrong: var( --neutral050 );--textNeutralMedium: var(--neutral300);--textNeutralSoft: var( --neutral400 );--textNeutralSofter: var(--neutral500);--textNeutralStrongInverted: var(--neutral900);--textNeutralSharedLight: var( --neutral900 );--textNeutralSharedDark: var( --neutral900 );--textPrimaryInitial: var(--primary500);--textPrimaryHover: var(--primary400);--textPrimaryPressed: var(--primary300);--textSecondaryInitial: var(--secondary500);--textSecondaryHover: var(--secondary400);--textSecondaryPressed: var(--secondary300);--textTertiaryInitial: var(--tertiary500);--textTertiaryHover: var(--tertiary400);--textTertiaryPressed: var(--tertiary300);--textPositiveInitial: var(--success500);--textPositiveHover: var(--success400);--textPositivePressed: var(--success300);--textNegativeInitial: var(--destructive400);--textNegativeHover: var(--destructive300);--textNegativePressed: var(--destructive200);--textWarningInitial: var(--warning500);--textWarningHover: var(--warning400);--textWarningPressed: var(--warning300);--iconNeutralStrong: var(--neutral050);--iconNeutralMedium: var(--neutral400);--iconNeutralSoft: var(--neutral500);--iconNeutralStrongInverted: var(--neutral900);--iconNeutralSharedLight: var(--neutral050);--iconNeutralSharedDark: var(--neutral900);--iconPrimaryInitial: var( --primary500 );--iconPrimaryHover: var(--primary400);--iconPrimaryPressed: var(--primary300);--iconSecondaryInitial: var(--secondary500);--iconSecondaryHover: var(--secondary400);--iconSecondaryPressed: var(--secondary300);--iconTertiaryInitial: var(--tertiary500);--iconTertiaryHover: var(--tertiary400);--iconTertiaryPressed: var(--tertiary300);--iconPositiveInitial: var(--success500);--iconPositiveHover: var(--success400);--iconPositivePressed: var(--success300);--iconNegativeInitial: var(--destructive400);--iconNegativeHover: var(--destructive300);--iconNegativePressed: var(--destructive200);--iconWarningInitial: var(--warning500);--iconWarningHover: var(--warning400);--iconWarningPressed: var(--warning300);--iconLabelPrimaryInitial: var(--neutral050);--iconLabelPrimaryDisabled: var(--neutral500);--overlayNeutralStronger: rgba( 36, 38, 49, .8 );--overlayNeutralStrong: rgba( 48, 51, 65, .8 );--overlayNeutralMedium: rgba(36, 38, 49, .4);--overlayNeutralSoft: rgba( 36, 38, 49, .2 );--illustrationsNeutral40: var(--neutral900);--illustrationsNeutral30: var(--neutral800);--illustrationsNeutral25: var(--neutral700);--illustrationsNeutral20: var(--neutral050);--illustrationsNeutral10: var(--neutral200);--illustrationsSuccess20: var(--success400);--illustrationsSuccess10: var(--success700);--illustrationsDestructive20: var(--destructive300);--illustrationsDestructive10: var(--destructive500);--illustrationsWarning20: var(--warning500);--illustrationsWarning10: var(--warning700);--illustrationsPrimary60: var(--primary050);--illustrationsPrimary50: var(--primary300);--illustrationsPrimary40: var(--primary500);--illustrationsPrimary30: var(--primary700);--illustrationsPrimary20: var(--primary800);--illustrationsPrimary10: var(--primary900);--illustrationsTransparency: .89;--chartStocks: var(--primary500);--chartEtps: var(--tertiary500);--chartMutualFunds: var(--destructive400);--chartIndexedFunds: var(--warning500);--chartOptions: var(--success500);--chartCrypto: var(--secondary500);--chartBlackRockFunds: var(--neutral050);--tradingViewSimpleChartActionDefault: var(--primary500);--tradingViewSimpleChartBackgroundPrimary: var(--neutral900);--tradingViewSimpleChartBackgroundSecondary: var(--neutral800);--tradingViewSimpleChartStrokeNeutralSoftInitial: var(--neutral700);--tradingViewSimpleChartPositive: var(--success400);--tradingViewSimpleChartNegative: var(--destructive300);--tradingViewSimpleChartLabelPrimary: var(--neutral900);--tradingViewSimpleChartLabelBackground: var(--neutral050);--progressBarBg: var(--iconNeutralSoft);--progressBarFill: var(--iconPositiveInitial);--modalThemeNormalOverlayBg: var(--overlayNeutralStrong);--modalThemeNormalContentOverlayBg: var(--surfaceCanvasPrimaryInitial);--modalThemeNormalContentOverlayElementBg: var(--overlayNeutralStronger);--modalThemeLighterOverlayBg: var(--overlayNeutralStronger);--modalThemeLighterContentOverlayBg: var(--surfaceCanvasSecondaryInitial);--modalThemeLighterContentOverlayElementBg: var(--overlayNeutralStrong);--modalBoxShadow: none}::-webkit-scrollbar-thumb{background:var(--neutral-700)}}:host([data-ht-theme="dark"]){--actionPrimaryInitial: var(--primary500);--actionPrimaryHover: var(--primary600);--actionPrimaryPressed: var(--primary700);--actionPrimaryDisabled: var(--neutral300);--actionPrimarySubtleInitial: var(--primary900);--actionPrimarySubtleHover: var(--primary800);--actionPrimarySubtlePressed: var(--primary750);--actionPrimarySubtleDisabled: var(--neutral700);--actionNegativeInitial: var(--destructive900);--actionNegativeHover: var(--destructive800);--actionNegativePressed: var(--destructive700);--actionNegativeDisabled: var(--neutral700);--labelPrimaryInitial: var( --neutral900 );--labelPrimaryDisabled: var(--neutral400);--labelPrimarySubtleInitial: var(--primary500);--labelPrimarySubtleHover: var(--primary400);--labelPrimarySubtlePressed: var(--primary300);--labelPrimarySubtleDisabled: var(--neutral400);--labelPrimarySubtleInactive: var(--neutral300);--labelPrimarySubtleActive: var(--neutral050);--labelNegativeInitial: var(--destructive400);--labelNegativeHover: var(--destructive300);--labelNegativePressed: var(--destructive200);--labelNegativeDisabled: var(--neutral400);--strokeNeutralStrongInitial: var( --neutral300 );--strokeNeutralStrongHover: var( --neutral050 );--strokeNeutralSoftInitial: var(--neutral700);--strokeNeutralSoftHover: var(--neutral600);--strokePrimaryInitial: var(--primary500);--strokePrimaryHover: var(--primary400);--strokePrimarySubtleInitial: var( --primary800 );--strokePrimarySubtleHover: var( --primary750 );--strokeNegativeInitial: var(--destructive400);--strokeNegativeHover: var(--destructive300);--strokePositiveInitial: var(--destructive400);--strokePositiveHover: var(--destructive300);--surfaceCanvasPrimaryInitial: var(--neutral900);--surfaceCanvasPrimaryHover: var(--neutral800);--surfaceCanvasPrimaryPressed: var(--neutral750);--surfaceCanvasSecondaryInitial: var(--neutral800);--surfaceCanvasSecondaryHover: var(--neutral750);--surfaceCanvasSecondaryPressed: var(--neutral700);--surfaceCanvasTertiaryInitial: var(--neutral750);--surfaceCanvasTertiaryHover: var(--neutral700);--surfaceCanvasTertiaryPressed: var(--neutral600);--surfacePrimaryInitial: var(--primary700);--surfacePrimaryHover: var(--primary600);--surfacePrimaryPressed: var(--primary600);--surfacePrimarySubtleInitial: var(--primary900);--surfacePrimarySubtleHover: var(--primary800);--surfacePrimarySubtlePressed: var(--primary750);--surfacePrimaryInvertedInitial: var(--black);--backgroundFixedButton: var(--neutral900);--surfaceSecondaryInitial: var(--secondary800);--surfaceSecondaryHover: var(--secondary700);--surfaceSecondaryPressed: var(--secondary600);--surfaceSecondarySubtleInitial: var(--secondary900);--surfaceSecondarySubtleHover: var(--secondary800);--surfaceSecondarySubtlePressed: var(--secondary750);--surfaceTertiaryInitial: var(--tertiary800);--surfaceTertiaryHover: var(--tertiary700);--surfaceTertiaryPressed: var(--tertiary600);--surfaceTertiarySubtleInitial: var(--tertiary900);--surfaceTertiarySubtleHover: var(--tertiary800);--surfaceTertiarySubtlePressed: var(--tertiary750);--surfacePositiveInitial: var(--success800);--surfacePositiveHover: var(--success700);--surfacePositivePressed: var(--success600);--surfacePositiveSubtleInitial: var(--success900);--surfacePositiveSubtleHover: var(--success800);--surfacePositiveSubtlePressed: var(--success750);--surfaceNegativeInitial: var(--destructive800);--surfaceNegativeHover: var(--destructive700);--surfaceNegativePressed: var(--destructive600);--surfaceNegativeSubtleInitial: var(--destructive900);--surfaceNegativeSubtleHover: var(--destructive800);--surfaceNegativeSubtlePressed: var(--destructive750);--surfaceWarningInitial: var(--warning800);--surfaceWarningHover: var(--warning700);--surfaceWarningPressed: var(--warning600);--surfaceWarningSubtleInitial: var(--warning900);--surfaceWarningSubtleHover: var(--warning800);--surfaceWarningSubtlePressed: var(--warning750);--textNeutralStrong: var( --neutral050 );--textNeutralMedium: var(--neutral300);--textNeutralSoft: var( --neutral400 );--textNeutralSofter: var(--neutral500);--textNeutralStrongInverted: var(--neutral900);--textNeutralSharedLight: var( --neutral900 );--textNeutralSharedDark: var( --neutral900 );--textPrimaryInitial: var(--primary500);--textPrimaryHover: var(--primary400);--textPrimaryPressed: var(--primary300);--textSecondaryInitial: var(--secondary500);--textSecondaryHover: var(--secondary400);--textSecondaryPressed: var(--secondary300);--textTertiaryInitial: var(--tertiary500);--textTertiaryHover: var(--tertiary400);--textTertiaryPressed: var(--tertiary300);--textPositiveInitial: var(--success500);--textPositiveHover: var(--success400);--textPositivePressed: var(--success300);--textNegativeInitial: var(--destructive400);--textNegativeHover: var(--destructive300);--textNegativePressed: var(--destructive200);--textWarningInitial: var(--warning500);--textWarningHover: var(--warning400);--textWarningPressed: var(--warning300);--iconNeutralStrong: var(--neutral050);--iconNeutralMedium: var(--neutral400);--iconNeutralSoft: var(--neutral500);--iconNeutralStrongInverted: var(--neutral900);--iconNeutralSharedLight: var(--neutral050);--iconNeutralSharedDark: var(--neutral900);--iconPrimaryInitial: var( --primary500 );--iconPrimaryHover: var(--primary400);--iconPrimaryPressed: var(--primary300);--iconSecondaryInitial: var(--secondary500);--iconSecondaryHover: var(--secondary400);--iconSecondaryPressed: var(--secondary300);--iconTertiaryInitial: var(--tertiary500);--iconTertiaryHover: var(--tertiary400);--iconTertiaryPressed: var(--tertiary300);--iconPositiveInitial: var(--success500);--iconPositiveHover: var(--success400);--iconPositivePressed: var(--success300);--iconNegativeInitial: var(--destructive400);--iconNegativeHover: var(--destructive300);--iconNegativePressed: var(--destructive200);--iconWarningInitial: var(--warning500);--iconWarningHover: var(--warning400);--iconWarningPressed: var(--warning300);--iconLabelPrimaryInitial: var(--neutral050);--iconLabelPrimaryDisabled: var(--neutral500);--overlayNeutralStronger: rgba( 36, 38, 49, .8 );--overlayNeutralStrong: rgba( 48, 51, 65, .8 );--overlayNeutralMedium: rgba(36, 38, 49, .4);--overlayNeutralSoft: rgba( 36, 38, 49, .2 );--illustrationsNeutral40: var(--neutral900);--illustrationsNeutral30: var(--neutral800);--illustrationsNeutral25: var(--neutral700);--illustrationsNeutral20: var(--neutral050);--illustrationsNeutral10: var(--neutral200);--illustrationsSuccess20: var(--success400);--illustrationsSuccess10: var(--success700);--illustrationsDestructive20: var(--destructive300);--illustrationsDestructive10: var(--destructive500);--illustrationsWarning20: var(--warning500);--illustrationsWarning10: var(--warning700);--illustrationsPrimary60: var(--primary050);--illustrationsPrimary50: var(--primary300);--illustrationsPrimary40: var(--primary500);--illustrationsPrimary30: var(--primary700);--illustrationsPrimary20: var(--primary800);--illustrationsPrimary10: var(--primary900);--chartStocks: var(--primary500);--chartEtps: var(--tertiary500);--chartMutualFunds: var(--destructive400);--chartIndexedFunds: var(--warning500);--chartOptions: var(--success500);--chartCrypto: var(--secondary500);--chartBlackRockFunds: var(--neutral050);--tradingViewSimpleChartActionDefault: var(--primary500);--tradingViewSimpleChartBackgroundPrimary: var(--neutral900);--tradingViewSimpleChartBackgroundSecondary: var(--neutral800);--tradingViewSimpleChartStrokeNeutralSoftInitial: var(--neutral700);--tradingViewSimpleChartPositive: var(--success400);--tradingViewSimpleChartNegative: var(--destructive300);--tradingViewSimpleChartLabelPrimary: var(--neutral900);--tradingViewSimpleChartLabelBackground: var(--neutral050);--progressBarBg: var(--iconNeutralSoft);--progressBarFill: var(--iconPositiveInitial);--modalThemeNormalOverlayBg: var(--overlayNeutralStrong);--modalThemeNormalContentOverlayBg: var(--surfaceCanvasPrimaryInitial);--modalThemeNormalContentOverlayElementBg: var(--overlayNeutralStronger);--modalThemeLighterOverlayBg: var(--overlayNeutralStronger);--modalThemeLighterContentOverlayBg: var(--surfaceCanvasSecondaryInitial);--modalThemeLighterContentOverlayElementBg: var(--overlayNeutralStrong);--modalBoxShadow: none}:host([data-ht-theme="light"]){--illustrationsNeutral40: var(--neutral100);--illustrationsNeutral30: var(--neutral050);--illustrationsNeutral25: var(--neutral300);--illustrationsNeutral20: var(--neutral800);--illustrationsNeutral10: var(--neutral900);--illustrationsSuccess20: var(--success700);--illustrationsSuccess10: var(--success300);--illustrationsDestructive20: var(--destructive500);--illustrationsDestructive10: var(--destructive300);--illustrationsWarning20: var(--warning700);--illustrationsWarning10: var(--warning500);--illustrationsPrimary60: var(--primary900);--illustrationsPrimary50: var(--primary800);--illustrationsPrimary40: var(--primary600);--illustrationsPrimary30: var(--primary500);--illustrationsPrimary20: var(--primary300);--illustrationsPrimary10: var(--primary050);--illustrationsTransparency: .2;--chartStocks: var(--primary600);--chartEtps: var(--tertiary600);--chartMutualFunds: var(--destructive500);--chartIndexedFunds: var(--warning600);--chartOptions: var(--success700);--chartCrypto: var(--secondary600);--chartBlackRockFunds: var(--neutral800);--overlayNeutralStronger: rgba( 244, 244, 244, .8 );--overlayNeutralStrong: rgba( 255, 255, 255, .8 );--overlayNeutralMedium: rgba(36, 38, 49, .4);--overlayNeutralSoft: rgba( 36, 38, 49, .2 );--actionPrimaryInitial: var(--primary500);--actionPrimaryHover: var(--primary600);--actionPrimaryPressed: var(--primary700);--actionPrimaryDisabled: var(--neutral300);--actionPrimarySubtleInitial: var(--primary050);--actionPrimarySubtleHover: var(--primary200);--actionPrimarySubtlePressed: var(--primary300);--actionPrimarySubtleDisabled: var(--neutral300);--actionNegativeInitial: var(--destructive050);--actionNegativeHover: var(--destructive300);--actionNegativePressed: var(--destructive500);--actionNegativeDisabled: var(--destructive050);--labelPrimaryInitial: var( --neutral900 );--labelPrimaryDisabled: var(--neutral500);--labelPrimarySubtleInitial: var(--primary600);--labelPrimarySubtleHover: var(--primary700);--labelPrimarySubtlePressed: var(--primary750);--labelPrimarySubtleDisabled: var(--neutral500);--labelPrimarySubtleInactive: var(--neutral700);--labelPrimarySubtleActive: var(--neutral900);--labelNegativeInitial: var(--destructive500);--labelNegativeHover: var(--destructive600);--labelNegativePressed: var(--destructive700);--labelNegativeDisabled: var(--neutral500);--strokeNeutralStrongInitial: var( --neutral700 );--strokeNeutralStrongHover: var( --neutral900 );--strokeNeutralSoftInitial: var(--neutral300);--strokeNeutralSoftHover: var(--neutral400);--strokePrimaryInitial: var(--primary600);--strokePrimaryHover: var(--primary700);--strokePrimarySubtleInitial: var( --primary300 );--strokePrimarySubtleHover: var( --primary500 );--strokeNegativeInitial: var(--destructive500);--strokeNegativeHover: var(--destructive600);--strokePositiveInitial: var(--success700);--strokePositiveHover: var(--success800);--surfaceCanvasPrimaryInitial: var(--neutral100);--surfaceCanvasPrimaryHover: var(--neutral200);--surfaceCanvasPrimaryPressed: var(--neutral300);--surfaceCanvasSecondaryInitial: var(--neutral050);--surfaceCanvasSecondaryHover: var(--neutral100);--surfaceCanvasSecondaryPressed: var(--neutral200);--surfaceCanvasTertiaryInitial: var(--neutral200);--surfaceCanvasTertiaryHover: var(--neutral300);--surfaceCanvasTertiaryPressed: var(--neutral400);--surfacePrimaryInitial: var(--primary500);--surfacePrimaryHover: var(--primary600);--surfacePrimaryPressed: var(--primary700);--surfacePrimarySubtleInitial: var(--primary050);--surfacePrimarySubtleHover: var(--primary200);--surfacePrimarySubtlePressed: var(--primary300);--surfacePrimaryInvertedInitial: var(--black);--backgroundFixedButton: var(--neutral200);--surfaceSecondaryInitial: var(--secondary400);--surfaceSecondaryHover: var(--secondary500);--surfaceSecondaryPressed: var(--secondary600);--surfaceSecondarySubtleInitial: var(--secondary050);--surfaceSecondarySubtleHover: var(--secondary200);--surfaceSecondarySubtlePressed: var(--secondary300);--surfaceTertiaryInitial: var(--tertiary400);--surfaceTertiaryHover: var(--tertiary500);--surfaceTertiaryPressed: var(--tertiary600);--surfaceTertiarySubtleInitial: var(--tertiary050);--surfaceTertiarySubtleHover: var(--tertiary200);--surfaceTertiarySubtlePressed: var(--tertiary300);--surfacePositiveInitial: var(--success400);--surfacePositiveHover: var(--success500);--surfacePositivePressed: var(--success600);--surfacePositiveSubtleInitial: var(--success050);--surfacePositiveSubtleHover: var(--success200);--surfacePositiveSubtlePressed: var(--success300);--surfaceNegativeInitial: var(--destructive400);--surfaceNegativeHover: var(--destructive500);--surfaceNegativePressed: var(--destructive600);--surfaceNegativeSubtleInitial: var(--destructive050);--surfaceNegativeSubtleHover: var(--destructive200);--surfaceNegativeSubtlePressed: var(--destructive300);--surfaceWarningInitial: var(--warning400);--surfaceWarningHover: var(--warning500);--surfaceWarningPressed: var(--warning600);--surfaceWarningSubtleInitial: var(--warning050);--surfaceWarningSubtleHover: var(--warning200);--surfaceWarningSubtlePressed: var(--warning300);--textNeutralStrong: var( --neutral900 );--textNeutralMedium: var(--neutral700);--textNeutralSoft: var( --neutral600 );--textNeutralSofter: var(--neutral400);--textNeutralStrongInverted: var(--neutral050);--textNeutralSharedLight: var( --neutral050 );--textNeutralSharedDark: var( --neutral900 );--textPrimaryInitial: var(--primary600);--textPrimaryHover: var(--primary700);--textPrimaryPressed: var(--primary750);--textSecondaryInitial: var(--secondary600);--textSecondaryHover: var(--secondary700);--textSecondaryPressed: var(--secondary800);--textTertiaryInitial: var(--tertiary600);--textTertiaryHover: var(--tertiary700);--textTertiaryPressed: var(--tertiary800);--textPositiveInitial: var(--success700);--textPositiveHover: var(--success800);--textPositivePressed: var(--success900);--textNegativeInitial: var(--destructive500);--textNegativeHover: var(--destructive600);--textNegativePressed: var(--destructive700);--textWarningInitial: var(--warning700);--textWarningHover: var(--warning800);--textWarningPressed: var(--warning900);--iconNeutralStrong: var(--neutral900);--iconNeutralMedium: var(--neutral600);--iconNeutralSoft: var(--neutral400);--iconNeutralStrongInverted: var(--neutral050);--iconNeutralSharedLight: var(--neutral050);--iconNeutralSharedDark: var(--neutral900);--iconPrimaryInitial: var( --primary600 );--iconPrimaryHover: var(--primary700);--iconPrimaryPressed: var(--primary750);--iconSecondaryInitial: var(--secondary600);--iconSecondaryHover: var(--secondary700);--iconSecondaryPressed: var(--secondary800);--iconTertiaryInitial: var(--tertiary600);--iconTertiaryHover: var(--tertiary700);--iconTertiaryPressed: var(--tertiary800);--iconPositiveInitial: var(--success700);--iconPositiveHover: var(--success800);--iconPositivePressed: var(--success900);--iconNegativeInitial: var(--destructive500);--iconNegativeHover: var(--destructive600);--iconNegativePressed: var(--destructive700);--iconWarningInitial: var(--warning700);--iconWarningHover: var(--warning800);--iconWarningPressed: var(--warning900);--iconLabelPrimaryInitial: var(--neutral900);--iconLabelPrimaryDisabled: var(--neutral400);--tradingViewSimpleChartActionDefault: var(--primary500);--tradingViewSimpleChartBackgroundPrimary: var(--neutral100);--tradingViewSimpleChartBackgroundSecondary: var(--neutral050);--tradingViewSimpleChartStrokeNeutralSoftInitial: var(--neutral300);--tradingViewSimpleChartPositive: var(--success700);--tradingViewSimpleChartNegative: var(--destructive400);--tradingViewSimpleChartLabelPrimary: var(--neutral900);--tradingViewSimpleChartLabelBackground: var(--neutral050);--progressBarBg: var(--iconNeutralSoft);--progressBarFill: var(--iconPositiveInitial);--modalThemeNormalOverlayBg: var(--overlayNeutralStrong);--modalThemeNormalContentOverlayBg: var(--surfaceCanvasPrimaryInitial);--modalThemeNormalContentOverlayElementBg: var(--overlayNeutralStronger);--modalThemeLighterOverlayBg: var(--overlayNeutralStronger);--modalThemeLighterContentOverlayBg: var(--surfaceCanvasSecondaryInitial);--modalThemeLighterContentOverlayElementBg: var(--overlayNeutralStrong);--modalBoxShadow: none}:host{--bpExtraSmall: 480px;--bpSmall: 768px;--bpMedium: 1024px;--bpLarge: 1280px;--bpExtraLarge: 1366px;--bpSmallHuge: 1600px;--bpHuge: 1920px;--largeWidth: 1240px;--mainWidth: 972px;--smallWidth: 720px;--smallerWidth: 580px;--tinyWidth: 343px;--tinyMedium: 200px;--carouselSmallHeight: 168px;--carouselSmallWidth: 224px;--carouselMediumHeight: 210px;--carouselMediumWidth: 280px;--ff900: "Inter900", sans-serif;--ff800: "Inter800", sans-serif;--ff700: "Inter700", sans-serif;--ff600: "Inter600", sans-serif;--ff500: "Inter500", sans-serif;--ff400: "Inter400", sans-serif;--ff300: "Inter300", sans-serif;--ff200: "Inter200", sans-serif;--ff100: "Inter100", sans-serif;--fontSizeExtraSmall: 10px;--fontSizeSmall: 12px;--fontSizeExtraBase: 14px;--fontSizeBase: 16px;--fontSizeMedium: 18px;--fontSizeLarge: 20px;--fontSizeExtraLarge: 24px;--fontSizeHugeMinus: 28px;--fontSizeHuge: 36px;--fontSizeMassive: 48px;--lineHeightExtraSmall: 12px;--lineHeightSmall: 16px;--lineHeightExtraBase: 20px;--lineHeightBase: 22px;--lineHeightExtraMedium: 24px;--lineHeightMedium: 26px;--lineHeightLarge: 28px;--lineHeightExtraLarge: 32px;--lineHeightHuge: 48px;--lineHeightMassive: 62px;--zIndexBelow: -1;--zIndexAbove: 1;--zIndexModal1: 10;--zIndexModal2: 25;--zIndexModal3: 50;--transitionUltraFast: .15s;--transitionFast: .25s;--transitionNormal: .5s;--transitionSlow: .75s;--headerHeight: 56px;--sidebarWidth: 88px;--footerHeight: 56px;--paddingHorizontal: 24px;--paddingHorizontalBigScreen: 22px;--spacingNone: 0px;--spacingExtraTiny: 2px;--spacingTinyMinus: 4px;--spacingTinyMedium: 6px;--spacingTiny: 8px;--spacingTinyPlus: 10px;--spacingSmallerMinus: 12px;--spacingSmaller: 16px;--spacingSmallerPlus: 18px;--spacingSmallerSuper: 20px;--spacingSmallMinus: 22px;--spacingSmall: 24px;--spacingSmallPlus: 28px;--spacingMedium: 32px;--spacingMediumIntermediate: 34px;--spacingMediumIntermediatePlus: 38px;--spacingMediumPlus: 40px;--spacingLargeMinus: 42px;--spacingLarge: 48px;--spacingHuge: 56px;--spacingMassive: 64px;--spacingMassivePlus: 68px;--spacingEnormousMinus: 72px;--spacingEnormous: 80px;--borderRadiusNone: 0px;--borderRadiusTiny: 2px;--borderRadiusTinyPlus: 4px;--borderRadiusSmall: 6px;--borderRadiusSmallPlus: 8px;--borderRadiusMedium: 10px;--borderRadiusMediumPlus: 12px;--borderRadiusLarge: 14px;--borderRadiusHuge: 18px;--borderRadiusMassive: 22px;--borderRadiusFull: 100%;--mainScrollbarWidth: 13px;--customModalScrollbarWidth: 5px;--cellHorizontalPadding: 17px;--readOnlyExtraVerticalSize: 8px;--fieldBorderRadius: 4px;--fieldSizeSmall: 40px;--fieldSizeNormal: 48px;--fieldSizeLarge: 60px;--fieldSizeHuge: 80px;--labelFontSize: var(--fontSizeSmall)}:host .m-none{margin:var(--spacingNone)}:host .m-extra-tiny{margin:var(--spacingExtraTiny)}:host .m-tiny-minus{margin:var(--spacingTinyMinus)}:host .m-tiny-medium{margin:var(--spacingTinyMedium)}:host .m-tiny{margin:var(--spacingTiny)}:host .m-tiny-plus{margin:var(--spacingTinyPlus)}:host .m-smaller-minus{margin:var(--spacingSmallerMinus)}:host .m-smaller{margin:var(--spacingSmaller)}:host .m-smaller-plus{margin:var(--spacingSmallerPlus)}:host .m-smaller-super{margin:var(--spacingSmallerSuper)}:host .m-small-minus{margin:var(--spacingSmallMinus)}:host .m-small{margin:var(--spacingSmall)}:host .m-small-plus{margin:var(--spacingSmallPlus)}:host .m-medium{margin:var(--spacingMedium)}:host .m-medium-intermediate{margin:var(--spacingMediumIntermediate)}:host .m-medium-intermediate-plus{margin:var(--spacingMediumIntermediatePlus)}:host .m-medium-plus{margin:var(--spacingMediumPlus)}:host .m-large-minus{margin:var(--spacingLargeMinus)}:host .m-large{margin:var(--spacingLarge)}:host .m-huge{margin:var(--spacingHuge)}:host .m-massive{margin:var(--spacingMassive)}:host .m-massive-plus{margin:var(--spacingMassivePlus)}:host .m-enormous-minus{margin:var(--spacingEnormousMinus)}:host .m-enormous{margin:var(--spacingEnormous)}:host .mt-none{margin-top:var(--spacingNone)}:host .mt-extra-tiny{margin-top:var(--spacingExtraTiny)}:host .mt-tiny-minus{margin-top:var(--spacingTinyMinus)}:host .mt-tiny-medium{margin-top:var(--spacingTinyMedium)}:host .mt-tiny{margin-top:var(--spacingTiny)}:host .mt-tiny-plus{margin-top:var(--spacingTinyPlus)}:host .mt-smaller-minus{margin-top:var(--spacingSmallerMinus)}:host .mt-smaller{margin-top:var(--spacingSmaller)}:host .mt-smaller-plus{margin-top:var(--spacingSmallerPlus)}:host .mt-smaller-super{margin-top:var(--spacingSmallerSuper)}:host .mt-small-minus{margin-top:var(--spacingSmallMinus)}:host .mt-small{margin-top:var(--spacingSmall)}:host .mt-small-plus{margin-top:var(--spacingSmallPlus)}:host .mt-medium{margin-top:var(--spacingMedium)}:host .mt-medium-intermediate{margin-top:var(--spacingMediumIntermediate)}:host .mt-medium-intermediate-plus{margin-top:var(--spacingMediumIntermediatePlus)}:host .mt-medium-plus{margin-top:var(--spacingMediumPlus)}:host .mt-large-minus{margin-top:var(--spacingLargeMinus)}:host .mt-large{margin-top:var(--spacingLarge)}:host .mt-huge{margin-top:var(--spacingHuge)}:host .mt-massive{margin-top:var(--spacingMassive)}:host .mt-massive-plus{margin-top:var(--spacingMassivePlus)}:host .mt-enormous-minus{margin-top:var(--spacingEnormousMinus)}:host .mt-enormous{margin-top:var(--spacingEnormous)}:host .mr-none{margin-right:var(--spacingNone)}:host .mr-extra-tiny{margin-right:var(--spacingExtraTiny)}:host .mr-tiny-minus{margin-right:var(--spacingTinyMinus)}:host .mr-tiny-medium{margin-right:var(--spacingTinyMedium)}:host .mr-tiny{margin-right:var(--spacingTiny)}:host .mr-tiny-plus{margin-right:var(--spacingTinyPlus)}:host .mr-smaller-minus{margin-right:var(--spacingSmallerMinus)}:host .mr-smaller{margin-right:var(--spacingSmaller)}:host .mr-smaller-plus{margin-right:var(--spacingSmallerPlus)}:host .mr-smaller-super{margin-right:var(--spacingSmallerSuper)}:host .mr-small-minus{margin-right:var(--spacingSmallMinus)}:host .mr-small{margin-right:var(--spacingSmall)}:host .mr-small-plus{margin-right:var(--spacingSmallPlus)}:host .mr-medium{margin-right:var(--spacingMedium)}:host .mr-medium-intermediate{margin-right:var(--spacingMediumIntermediate)}:host .mr-medium-intermediate-plus{margin-right:var(--spacingMediumIntermediatePlus)}:host .mr-medium-plus{margin-right:var(--spacingMediumPlus)}:host .mr-large-minus{margin-right:var(--spacingLargeMinus)}:host .mr-large{margin-right:var(--spacingLarge)}:host .mr-huge{margin-right:var(--spacingHuge)}:host .mr-massive{margin-right:var(--spacingMassive)}:host .mr-massive-plus{margin-right:var(--spacingMassivePlus)}:host .mr-enormous-minus{margin-right:var(--spacingEnormousMinus)}:host .mr-enormous{margin-right:var(--spacingEnormous)}:host .mb-none{margin-bottom:var(--spacingNone)}:host .mb-extra-tiny{margin-bottom:var(--spacingExtraTiny)}:host .mb-tiny-minus{margin-bottom:var(--spacingTinyMinus)}:host .mb-tiny-medium{margin-bottom:var(--spacingTinyMedium)}:host .mb-tiny{margin-bottom:var(--spacingTiny)}:host .mb-tiny-plus{margin-bottom:var(--spacingTinyPlus)}:host .mb-smaller-minus{margin-bottom:var(--spacingSmallerMinus)}:host .mb-smaller{margin-bottom:var(--spacingSmaller)}:host .mb-smaller-plus{margin-bottom:var(--spacingSmallerPlus)}:host .mb-smaller-super{margin-bottom:var(--spacingSmallerSuper)}:host .mb-small-minus{margin-bottom:var(--spacingSmallMinus)}:host .mb-small{margin-bottom:var(--spacingSmall)}:host .mb-small-plus{margin-bottom:var(--spacingSmallPlus)}:host .mb-medium{margin-bottom:var(--spacingMedium)}:host .mb-medium-intermediate{margin-bottom:var(--spacingMediumIntermediate)}:host .mb-medium-intermediate-plus{margin-bottom:var(--spacingMediumIntermediatePlus)}:host .mb-medium-plus{margin-bottom:var(--spacingMediumPlus)}:host .mb-large-minus{margin-bottom:var(--spacingLargeMinus)}:host .mb-large{margin-bottom:var(--spacingLarge)}:host .mb-huge{margin-bottom:var(--spacingHuge)}:host .mb-massive{margin-bottom:var(--spacingMassive)}:host .mb-massive-plus{margin-bottom:var(--spacingMassivePlus)}:host .mb-enormous-minus{margin-bottom:var(--spacingEnormousMinus)}:host .mb-enormous{margin-bottom:var(--spacingEnormous)}:host .ml-none{margin-left:var(--spacingNone)}:host .ml-extra-tiny{margin-left:var(--spacingExtraTiny)}:host .ml-tiny-minus{margin-left:var(--spacingTinyMinus)}:host .ml-tiny-medium{margin-left:var(--spacingTinyMedium)}:host .ml-tiny{margin-left:var(--spacingTiny)}:host .ml-tiny-plus{margin-left:var(--spacingTinyPlus)}:host .ml-smaller-minus{margin-left:var(--spacingSmallerMinus)}:host .ml-smaller{margin-left:var(--spacingSmaller)}:host .ml-smaller-plus{margin-left:var(--spacingSmallerPlus)}:host .ml-smaller-super{margin-left:var(--spacingSmallerSuper)}:host .ml-small-minus{margin-left:var(--spacingSmallMinus)}:host .ml-small{margin-left:var(--spacingSmall)}:host .ml-small-plus{margin-left:var(--spacingSmallPlus)}:host .ml-medium{margin-left:var(--spacingMedium)}:host .ml-medium-intermediate{margin-left:var(--spacingMediumIntermediate)}:host .ml-medium-intermediate-plus{margin-left:var(--spacingMediumIntermediatePlus)}:host .ml-medium-plus{margin-left:var(--spacingMediumPlus)}:host .ml-large-minus{margin-left:var(--spacingLargeMinus)}:host .ml-large{margin-left:var(--spacingLarge)}:host .ml-huge{margin-left:var(--spacingHuge)}:host .ml-massive{margin-left:var(--spacingMassive)}:host .ml-massive-plus{margin-left:var(--spacingMassivePlus)}:host .ml-enormous-minus{margin-left:var(--spacingEnormousMinus)}:host .ml-enormous{margin-left:var(--spacingEnormous)}:host .p-none{padding:var(--spacingNone)}:host .p-extra-tiny{padding:var(--spacingExtraTiny)}:host .p-tiny-minus{padding:var(--spacingTinyMinus)}:host .p-tiny-medium{padding:var(--spacingTinyMedium)}:host .p-tiny{padding:var(--spacingTiny)}:host .p-tiny-plus{padding:var(--spacingTinyPlus)}:host .p-smaller-minus{padding:var(--spacingSmallerMinus)}:host .p-smaller{padding:var(--spacingSmaller)}:host .p-smaller-plus{padding:var(--spacingSmallerPlus)}:host .p-smaller-super{padding:var(--spacingSmallerSuper)}:host .p-small-minus{padding:var(--spacingSmallMinus)}:host .p-small{padding:var(--spacingSmall)}:host .p-small-plus{padding:var(--spacingSmallPlus)}:host .p-medium{padding:var(--spacingMedium)}:host .p-medium-intermediate{padding:var(--spacingMediumIntermediate)}:host .p-medium-intermediate-plus{padding:var(--spacingMediumIntermediatePlus)}:host .p-medium-plus{padding:var(--spacingMediumPlus)}:host .p-large-minus{padding:var(--spacingLargeMinus)}:host .p-large{padding:var(--spacingLarge)}:host .p-huge{padding:var(--spacingHuge)}:host .p-massive{padding:var(--spacingMassive)}:host .p-massive-plus{padding:var(--spacingMassivePlus)}:host .p-enormous-minus{padding:var(--spacingEnormousMinus)}:host .p-enormous{padding:var(--spacingEnormous)}:host .pt-none{padding-top:var(--spacingNone)}:host .pt-extra-tiny{padding-top:var(--spacingExtraTiny)}:host .pt-tiny-minus{padding-top:var(--spacingTinyMinus)}:host .pt-tiny-medium{padding-top:var(--spacingTinyMedium)}:host .pt-tiny{padding-top:var(--spacingTiny)}:host .pt-tiny-plus{padding-top:var(--spacingTinyPlus)}:host .pt-smaller-minus{padding-top:var(--spacingSmallerMinus)}:host .pt-smaller{padding-top:var(--spacingSmaller)}:host .pt-smaller-plus{padding-top:var(--spacingSmallerPlus)}:host .pt-smaller-super{padding-top:var(--spacingSmallerSuper)}:host .pt-small-minus{padding-top:var(--spacingSmallMinus)}:host .pt-small{padding-top:var(--spacingSmall)}:host .pt-small-plus{padding-top:var(--spacingSmallPlus)}:host .pt-medium{padding-top:var(--spacingMedium)}:host .pt-medium-intermediate{padding-top:var(--spacingMediumIntermediate)}:host .pt-medium-intermediate-plus{padding-top:var(--spacingMediumIntermediatePlus)}:host .pt-medium-plus{padding-top:var(--spacingMediumPlus)}:host .pt-large-minus{padding-top:var(--spacingLargeMinus)}:host .pt-large{padding-top:var(--spacingLarge)}:host .pt-huge{padding-top:var(--spacingHuge)}:host .pt-massive{padding-top:var(--spacingMassive)}:host .pt-massive-plus{padding-top:var(--spacingMassivePlus)}:host .pt-enormous-minus{padding-top:var(--spacingEnormousMinus)}:host .pt-enormous{padding-top:var(--spacingEnormous)}:host .pr-none{padding-right:var(--spacingNone)}:host .pr-extra-tiny{padding-right:var(--spacingExtraTiny)}:host .pr-tiny-minus{padding-right:var(--spacingTinyMinus)}:host .pr-tiny-medium{padding-right:var(--spacingTinyMedium)}:host .pr-tiny{padding-right:var(--spacingTiny)}:host .pr-tiny-plus{padding-right:var(--spacingTinyPlus)}:host .pr-smaller-minus{padding-right:var(--spacingSmallerMinus)}:host .pr-smaller{padding-right:var(--spacingSmaller)}:host .pr-smaller-plus{padding-right:var(--spacingSmallerPlus)}:host .pr-smaller-super{padding-right:var(--spacingSmallerSuper)}:host .pr-small-minus{padding-right:var(--spacingSmallMinus)}:host .pr-small{padding-right:var(--spacingSmall)}:host .pr-small-plus{padding-right:var(--spacingSmallPlus)}:host .pr-medium{padding-right:var(--spacingMedium)}:host .pr-medium-intermediate{padding-right:var(--spacingMediumIntermediate)}:host .pr-medium-intermediate-plus{padding-right:var(--spacingMediumIntermediatePlus)}:host .pr-medium-plus{padding-right:var(--spacingMediumPlus)}:host .pr-large-minus{padding-right:var(--spacingLargeMinus)}:host .pr-large{padding-right:var(--spacingLarge)}:host .pr-huge{padding-right:var(--spacingHuge)}:host .pr-massive{padding-right:var(--spacingMassive)}:host .pr-massive-plus{padding-right:var(--spacingMassivePlus)}:host .pr-enormous-minus{padding-right:var(--spacingEnormousMinus)}:host .pr-enormous{padding-right:var(--spacingEnormous)}:host .pb-none{padding-bottom:var(--spacingNone)}:host .pb-extra-tiny{padding-bottom:var(--spacingExtraTiny)}:host .pb-tiny-minus{padding-bottom:var(--spacingTinyMinus)}:host .pb-tiny-medium{padding-bottom:var(--spacingTinyMedium)}:host .pb-tiny{padding-bottom:var(--spacingTiny)}:host .pb-tiny-plus{padding-bottom:var(--spacingTinyPlus)}:host .pb-smaller-minus{padding-bottom:var(--spacingSmallerMinus)}:host .pb-smaller{padding-bottom:var(--spacingSmaller)}:host .pb-smaller-plus{padding-bottom:var(--spacingSmallerPlus)}:host .pb-smaller-super{padding-bottom:var(--spacingSmallerSuper)}:host .pb-small-minus{padding-bottom:var(--spacingSmallMinus)}:host .pb-small{padding-bottom:var(--spacingSmall)}:host .pb-small-plus{padding-bottom:var(--spacingSmallPlus)}:host .pb-medium{padding-bottom:var(--spacingMedium)}:host .pb-medium-intermediate{padding-bottom:var(--spacingMediumIntermediate)}:host .pb-medium-intermediate-plus{padding-bottom:var(--spacingMediumIntermediatePlus)}:host .pb-medium-plus{padding-bottom:var(--spacingMediumPlus)}:host .pb-large-minus{padding-bottom:var(--spacingLargeMinus)}:host .pb-large{padding-bottom:var(--spacingLarge)}:host .pb-huge{padding-bottom:var(--spacingHuge)}:host .pb-massive{padding-bottom:var(--spacingMassive)}:host .pb-massive-plus{padding-bottom:var(--spacingMassivePlus)}:host .pb-enormous-minus{padding-bottom:var(--spacingEnormousMinus)}:host .pb-enormous{padding-bottom:var(--spacingEnormous)}:host .pl-none{padding-left:var(--spacingNone)}:host .pl-extra-tiny{padding-left:var(--spacingExtraTiny)}:host .pl-tiny-minus{padding-left:var(--spacingTinyMinus)}:host .pl-tiny-medium{padding-left:var(--spacingTinyMedium)}:host .pl-tiny{padding-left:var(--spacingTiny)}:host .pl-tiny-plus{padding-left:var(--spacingTinyPlus)}:host .pl-smaller-minus{padding-left:var(--spacingSmallerMinus)}:host .pl-smaller{padding-left:var(--spacingSmaller)}:host .pl-smaller-plus{padding-left:var(--spacingSmallerPlus)}:host .pl-smaller-super{padding-left:var(--spacingSmallerSuper)}:host .pl-small-minus{padding-left:var(--spacingSmallMinus)}:host .pl-small{padding-left:var(--spacingSmall)}:host .pl-small-plus{padding-left:var(--spacingSmallPlus)}:host .pl-medium{padding-left:var(--spacingMedium)}:host .pl-medium-intermediate{padding-left:var(--spacingMediumIntermediate)}:host .pl-medium-intermediate-plus{padding-left:var(--spacingMediumIntermediatePlus)}:host .pl-medium-plus{padding-left:var(--spacingMediumPlus)}:host .pl-large-minus{padding-left:var(--spacingLargeMinus)}:host .pl-large{padding-left:var(--spacingLarge)}:host .pl-huge{padding-left:var(--spacingHuge)}:host .pl-massive{padding-left:var(--spacingMassive)}:host .pl-massive-plus{padding-left:var(--spacingMassivePlus)}:host .pl-enormous-minus{padding-left:var(--spacingEnormousMinus)}:host .pl-enormous{padding-left:var(--spacingEnormous)}:host{--transparent: rgba(0, 0, 0, 0);--black: #000000;--primary900: #453838;--primary800: #7c5545;--primary750: #a95832;--primary700: #e16017;--primary600: #ff7324;--primary500: #ff9b63;--primary400: #ffaf82;--primary300: #ffc3a1;--primary200: #ffd7c1;--primary100: #ffebe0;--primary050: #f6e7de;--secondary900: #452f49;--secondary800: #66144f;--secondary750: #881b69;--secondary700: #b2248a;--secondary600: #e52eb2;--secondary500: #ff63d3;--secondary400: #ff99e2;--secondary300: #ffb2e9;--secondary200: #ffccf1;--secondary100: #ffe5f8;--secondary050: #f6deef;--tertiary900: #2a3b4f;--tertiary800: #174b92;--tertiary750: #1a56a7;--tertiary700: #256ab5;--tertiary600: #368ed8;--tertiary500: #4bb5fc;--tertiary400: #77cffd;--tertiary300: #93dffe;--tertiary200: #b7eefe;--tertiary100: #dbf8fe;--tertiary050: #dbebf5;--success900: #2d4546;--success800: #1f8c85;--success750: #21968f;--success700: #2da08d;--success600: #48d0ac;--success500: #63f3be;--success400: #89f7c4;--success300: #a2fbc8;--success200: #c1fdd5;--success100: #e0fee7;--success050: #d7f4e7;--warning900: #453f34;--warning800: #936416;--warning750: #a97319;--warning700: #b78423;--warning600: #dba633;--warning500: #ffca47;--warning400: #ffdb75;--warning300: #ffe590;--warning200: #fff0b5;--warning100: #fff8da;--warning050: #f6ecd1;--destructive900: #442838;--destructive800: #921052;--destructive750: #a5125d;--destructive700: #b51a5a;--destructive600: #d8265f;--destructive500: #fc3561;--destructive400: #fd677a;--destructive300: #fe8589;--destructive200: #feb3ae;--destructive100: #feddd6;--destructive050: #f5d7de;--neutral900: #242631;--neutral800: #303341;--neutral750: #454654;--neutral700: #595b67;--neutral600: #6f717c;--neutral500: #858790;--neutral400: #9c9da5;--neutral300: #d7d8da;--neutral200: #f4f4f4;--neutral100: #f8f8f8;--neutral050: #ffffff;--illustrationsPomelo60: var(--primary900);--illustrationsPomelo50: var(--primary800);--illustrationsPomelo40: var(--primary600);--illustrationsPomelo30: var(--primary500);--illustrationsPomelo20: var(--primary300);--illustrationsPomelo10: var(--primary050);--illustrationsKale20: var(--success700);--illustrationsKale10: var(--success400);--illustrationsWaterfall30: var(--tertiary800);--illustrationsWaterfall20: var(--tertiary700);--illustrationsWaterfall10: var(--tertiary500);--illustrationsCherry30: var(--destructive800);--illustrationsCherry20: var(--destructive500);--illustrationsCherry10: var(--destructive300);--illustrationsBanana10: var(--warning500);--illustrationsCommonNeutral60: var(--neutral900);--illustrationsCommonNeutral50: var(--neutral900);--illustrationsCommonNeutral40: var(--neutral800);--illustrationsCommonNeutral30: var(--neutral600);--illustrationsCommonNeutral20: var(--neutral200);--illustrationsCommonNeutral10: var(--neutral050)}:host{--fadeOutDurationSlow: 1s;--fadeOutDuration: .6s;--fadeOutDurationFast: .3s;--fadeOutDurationUltraFast: .15s;--fadeInDurationSlow: 1s;--fadeInDuration: .6s;--fadeInDurationFast: .3s;--fadeInDurationUltraFast: .15s}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.--fade-out-animation{animation:fadeOut var(--fadeOutDuration)}.--fade-out-animation-slow{animation:fadeOut var(--fadeOutDurationSlow)}.--fade-out-animation-fast{animation:fadeOut var(--fadeOutDurationFast)}.--fade-out-animation-ultra-fast{animation:fadeOut var(--fadeOutDurationUltraFast)}.--fade-in-animation{animation:fadeIn var(--fadeInDuration)}.--fade-in-animation-slow{animation:fadeIn var(--fadeInDurationSlow)}.--fade-in-animation-fast{animation:fadeIn var(--fadeInDurationFast)}.--fade-in-animation-ultra-fast{animation:fadeIn var(--fadeInDurationUltraFast)}@media (prefers-reduced-motion){.--fade-out-animation-slow,.--fade-out-animation,.--fade-out-animation-fast,.--fade-out-animation-ultra-fast,.--fade-in-animation-slow,.--fade-in-animation,.--fade-in-animation-fast,.--fade-in-animation-ultra-fast{animation-duration:0ms}}:host .rounded-img{height:100%;position:relative}:host .space{white-space:pre-line}:host .nowrap{white-space:nowrap}:host .primary--text{color:var(--textNeutralStrong)}:host .secondary--text{color:var(--textNeutralMedium)}:host .tertiary--text{color:var(--textNeutralSoft)}:host .positive--text{color:var(--textPositiveInitial)}:host .negative--text{color:var(--textNegativeInitial)}:host .orange--text{color:var(--iconPrimaryInitial)}:host .warning--text{color:var(--surfaceWarningInitial)}:host .primary-negative--text{color:var(--textNegativeInitial)}:host .dark--label-title{color:var(--textNeutralSoft)}:host .--text-center{text-align:center!important}:host .--text-right{text-align:right!important}:host .--text-primary{color:var(--textNeutralStrong)}:host .--text-secondary{color:var(--textNeutralMedium)}:host .--text-tertiary{color:var(--textNeutralSoft)}:host .--text-positive{color:var(--textPositiveInitial)}:host .--text-negative{color:var(--textNegativeInitial)}:host .--text-icon-nav-and-controls{color:var(--iconPrimaryInitial)}:host .--text-warning{color:var(--textWarningInitial)}:host .--text-primary-base{color:var(--surfaceCanvasPrimaryInitial)}:host .--text-inherit-color{color:inherit}:host .text-decoration-underline{text-decoration:underline}:host .text-decoration-none{text-decoration:none}:host .--capitalize:first-letter{text-transform:capitalize}:host .--uppercase{text-transform:uppercase}:host .--width-fit-content,:host .width-fit-content{width:-moz-fit-content!important;width:fit-content!important}:host .bg-primary-base{background-color:var(--surfaceCanvasPrimaryInitial)}:host .bg-secondary-base{background-color:var(--surfaceCanvasSecondaryInitial)}:host .bg-tertiary-base{background-color:var(--surfaceCanvasTertiaryInitial)}:host .bg-status-positive{background-color:var(--surfacePositiveInitial)}:host .bg-status-negative{background-color:var(--surfaceNegativeInitial)}:host .bg-status-warning{background-color:var(--surfaceWarningInitial)}:host .bg-transparent{background-color:var(--transparent)!important}:host .bg-banner1{background-color:var(--surfacePrimarySubtleInitial)}:host .bg-banner2{background-color:var(--surfaceSecondarySubtleInitial)}:host .bg-banner3{background-color:var(--surfaceTertiarySubtleInitial)}:host .bg-banner4{background-color:var(--surfacePositiveSubtleInitial)}:host .bg-banner5{background-color:var(--surfaceWarningSubtleInitial)}:host .bg-banner6{background-color:var(--surfaceNegativeSubtleInitial)}:host .bg-banner7{background-color:var(--surfaceTertiaryInitial)}:host .bg-banner8{background-color:var(--surfacePrimaryInvertedInitial)}:host .bg-fixed-button{background-color:var(--backgroundFixedButton)}:host .border-color-primary-base{border-color:var(--surfaceCanvasPrimaryInitial)}:host .border-color-secondary-base{border-color:var(--surfaceCanvasSecondaryInitial)}:host .border-color-tertiary-base{border-color:var(--surfaceCanvasTertiaryInitial)}:host .border-color-status-positive{border-color:var(--surfacePositiveInitial)}:host .border-color-status-negative{border-color:var(--surfaceNegativeInitial)}:host .border-color-status-warning{border-color:var(--surfaceWarningInitial)}:host .border-color-transparent{border-color:var(--transparent)!important}:host .border-color-stroke-divider{border-color:var(--strokeNeutralSoftInitial)!important}:host .border-color-banner1{border-color:var(--surfacePrimarySubtleInitial)}:host .border-color-banner2{border-color:var(--surfaceSecondarySubtleInitial)}:host .border-color-banner3{border-color:var(--surfaceTertiarySubtleInitial)}:host .border-color-banner4{border-color:var(--surfacePositiveSubtleInitial)}:host .border-color-banner5{border-color:var(--surfaceWarningSubtleInitial)}:host .border-color-banner6{border-color:var(--surfaceNegativeSubtleInitial)}:host .border-color-banner7{border-color:var(--surfaceTertiaryInitial)}:host .border-color-banner8{border-color:var(--surfacePrimaryInvertedInitial)}:host .border-color-fixed-button{border-color:var(--backgroundFixedButton)}:host .border-color-icon-and-nav-controls{border-color:var(--iconPrimaryInitial)}:host .d-flex{display:flex}:host .d-flex-row{flex-direction:row}:host .d-flex-col{flex-direction:column}:host .d-flex-rev-row{flex-direction:row-reverse}:host .d-flex-rev-col{flex-direction:column-reverse}:host .d-inline{display:inline}:host .d-inline-flex{display:inline-flex}:host .d-none{display:none}:host .align-center{align-items:center}:host .align-self-start{align-self:flex-start}:host .align-self-center{align-self:center}:host .align-self-end{align-self:end}:host .align-start{align-items:flex-start!important}:host .align-end{align-items:flex-end}:host .align-baseline{align-items:baseline}:host .align-stretch{align-items:stretch}:host .justify-center{justify-content:center!important}:host .justify-space-between{justify-content:space-between!important}:host .justify-start{justify-content:flex-start!important}:host .justify-end{justify-content:flex-end!important}:host .text-center{text-align:center}:host .text-left{text-align:left}:host .text-right{text-align:right}:host .text-justify{text-align:justify}:host .h-100{height:100%}:host .w-100{width:100%}:host .p-absolute{position:absolute}:host .p-relative{position:relative}:host .p-fixed{position:fixed}:host .p-static{position:static}:host .p-sticky{position:sticky}:host .p-inherit{position:inherit}:host .p-initial{position:initial}`;
var gt = Object.defineProperty, yt = Object.getOwnPropertyDescriptor, v = (t, e, a, r) => {
  for (var i = r > 1 ? void 0 : r ? yt(e, a) : e, s = t.length - 1, n; s >= 0; s--)
    (n = t[s]) && (i = (r ? n(e, a, i) : n(i)) || i);
  return r && i && gt(e, a, i), i;
};
let y = class extends m {
  constructor() {
    super(...arguments), this.customerId = "", this.questions = [
      {
        title: l.translate("chat.prompts.question1"),
        description: l.translate("chat.prompts.question1")
      },
      {
        title: l.translate("chat.prompts.question2"),
        description: l.translate("chat.prompts.question2")
      },
      {
        title: l.translate("chat.prompts.question3"),
        description: l.translate("chat.prompts.question3")
      },
      {
        title: l.translate("chat.prompts.question4"),
        description: l.translate("chat.prompts.question4")
      }
    ], this.locale = "en", this.translations = {}, this.auth = null, this.chatScreenRef = C(), this.defaultPrompt = "";
  }
  connectedCallback() {
    var e;
    super.connectedCallback();
    const t = document.createElement("style");
    t.textContent = le, (e = this.shadowRoot) == null || e.appendChild(t);
  }
  firstUpdated(t) {
    t.has("locale") && l.updateLocale(this.locale), t.has("translations") && l.updateTranslations(this.translations);
  }
  setAuth(t) {
    if (!(t != null && t.apiKey) || !(t != null && t.authToken) || !(t != null && t.baseURL))
      throw new Error("Invalid auth config");
    this.auth = t;
  }
  /**
   * Sends a message through the chat interface
   * @param message The message to be sent
   */
  sendMessage(t) {
    var e, a, r;
    if (!this.auth)
      throw new Error("Auth not set");
    if ((a = (e = this.chatScreenRef.value) == null ? void 0 : e.chatController) != null && a.isLegalAccepted) {
      (r = this.chatScreenRef.value) == null || r.send(t);
      return;
    }
    this.defaultPrompt = t;
  }
  render() {
    return c`
      <chat-screen
        ${w(this.chatScreenRef)}
        .questions=${this.questions}
        .customerId=${this.customerId}
        .auth=${this.auth ?? null}
        .defaultPrompt=${this.defaultPrompt}
      ></chat-screen>
    `;
  }
};
y.styles = d`
    :host {
      display: block;
      height: 100%;
    }
  `;
v([
  o({ type: String })
], y.prototype, "customerId", 2);
v([
  o({ type: Array })
], y.prototype, "questions", 2);
v([
  o({ type: String })
], y.prototype, "locale", 2);
v([
  o({ type: Object })
], y.prototype, "translations", 2);
v([
  o({ type: Object, reflect: !1 })
], y.prototype, "auth", 2);
v([
  _()
], y.prototype, "chatScreenRef", 2);
v([
  _()
], y.prototype, "defaultPrompt", 2);
y = v([
  u("finny-app")
], y);
const ia = "finny-app";
let M = class extends m {
  constructor() {
    super(...arguments), this.company = "Company", this.questions = [
      {
        title: l.translate("askFinnyAbout.prompts.question1", {
          company: this.company
        }),
        description: l.translate("askFinnyAbout.prompts.question1", {
          company: this.company
        })
      },
      {
        title: l.translate("askFinnyAbout.prompts.question2", {
          company: this.company
        }),
        description: l.translate("askFinnyAbout.prompts.question2", {
          company: this.company
        })
      },
      {
        title: l.translate("askFinnyAbout.prompts.question3", {
          company: this.company
        }),
        description: l.translate("askFinnyAbout.prompts.question3", {
          company: this.company
        })
      },
      {
        title: l.translate("askFinnyAbout.prompts.question4", {
          company: this.company
        }),
        description: l.translate("askFinnyAbout.prompts.question4", {
          company: this.company
        })
      }
    ], this.locale = "en", this.translations = {};
  }
  connectedCallback() {
    var e;
    super.connectedCallback();
    const t = document.createElement("style");
    t.textContent = le, (e = this.shadowRoot) == null || e.appendChild(t);
  }
  firstUpdated(t) {
    t.has("locale") && l.updateLocale(this.locale), t.has("translations") && l.updateTranslations(this.translations);
  }
  render() {
    return c`
      <ask-finny-about
        .company=${this.company}
        .questions=${this.questions}
        .locale=${this.locale}
      ></ask-finny-about>
    `;
  }
};
M.styles = d`
    :host {
      display: block;
      height: 100%;
    }
  `;
v([
  o({ type: String })
], M.prototype, "company", 2);
v([
  o({ type: Array })
], M.prototype, "questions", 2);
v([
  o({ type: String })
], M.prototype, "locale", 2);
v([
  o({ type: Object })
], M.prototype, "translations", 2);
M = v([
  u("ask-finny-about-widget")
], M);
const sa = "ask-finny-about-widget";
export {
  sa as AskFinnyAboutComponent,
  M as AskFinnyAboutWidget,
  y as FinnyApp,
  ia as FinnyAppComponent
};
//# sourceMappingURL=index.js.map
